export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  Upload: any;
};

export type Advance = {
  __typename?: 'Advance';
  /** What type of advance this is (example: pull). */
  advanceType: Scalars['String'];
  /** The fee associated with this advance. */
  fee?: Maybe<AdvanceFee>;
  /** Primary key for the advance. */
  id: Scalars['ID'];
  /** Returns whether the advance was for a savings product. */
  isSavings: Scalars['Boolean'];
  /** The pay period associated with this advance. */
  payPeriod: PayPeriod;
  /** Total dollar amount in cents for this advance (excluding fees). */
  totalAmountCents: Scalars['Int'];
  /**
   * Total dollar amount of fees in cents for this advance.
   * @deprecated Use the information from the fee field.
   */
  totalFeeAmountCents: Scalars['Int'];
};

/** The connection type for Advance. */
export type AdvanceConnection = {
  __typename?: 'AdvanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdvanceEdge>>>;
  /** A page of Advance objects. */
  items: Array<Advance>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Advance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AdvanceEdge = {
  __typename?: 'AdvanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Advance>;
};

export type AdvanceFee = {
  __typename?: 'AdvanceFee';
  /** The total amount of the fee. */
  totalAmountCents: Scalars['Int'];
  /** True if the fee was waived. */
  waived: Scalars['Boolean'];
};

export type Announcement = {
  __typename?: 'Announcement';
  /** The ID of the announcement */
  id: Scalars['String'];
  /** The message to be displayed */
  message: Scalars['String'];
  /** The title of the announcement */
  title: Scalars['String'];
};

/** The connection type for Announcement. */
export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AnnouncementEdge>>>;
  /** A page of Announcement objects. */
  items: Array<Announcement>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Announcement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AnnouncementEdge = {
  __typename?: 'AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Announcement>;
};

/** A log of an api request and corresponding response */
export type ApiResponseLog = {
  __typename?: 'ApiResponseLog';
  /** Time API request was made. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Full request JSON of the POST body. */
  request?: Maybe<Scalars['String']>;
  /** Response message. */
  response: Scalars['String'];
};

export enum ApiResponseLogCategory {
  /** Direct deposit update API logs. */
  DirectDepositUpdates = 'DIRECT_DEPOSIT_UPDATES',
  /** Net earnings API logs. */
  NetEarnings = 'NET_EARNINGS',
  /** Gross earnings API logs. */
  GrossEarnings = 'GROSS_EARNINGS',
  /** User roster API logs. */
  UserRoster = 'USER_ROSTER'
}

/** The connection type for ApiResponseLog. */
export type ApiResponseLogConnection = {
  __typename?: 'ApiResponseLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ApiResponseLogEdge>>>;
  /** A page of ApiResponseLog objects. */
  items: Array<ApiResponseLog>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ApiResponseLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ApiResponseLogEdge = {
  __typename?: 'ApiResponseLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ApiResponseLog>;
};

export type Attachment = {
  __typename?: 'Attachment';
  /** The filepath of the attachment */
  path?: Maybe<Scalars['String']>;
  /** The AWS direct link with an authorization token */
  url?: Maybe<Scalars['String']>;
};

export enum AvailableBalancePayoffMethodCategory {
  /** The payoff method that subtracts the entire negative balance from the next paycheck. */
  Workoff = 'WORKOFF',
  /** The payment method that charges the entire negative balance to the employee's bank account. */
  AchDebit = 'ACH_DEBIT',
  /** The payment method that subtracts the entire negative balance from the next paycheck. This is only available under certain conditions; if auto-workoff is available, it should be created without user input. */
  AutoWorkoff = 'AUTO_WORKOFF',
  /** The payment method that subtracts the negative balance evenly across a variable number of future paychecks. */
  PaymentPlan = 'PAYMENT_PLAN'
}

export type BinMessage = {
  __typename?: 'BINMessage';
  /** True if debit card may be created for this BIN. */
  allowCardCreation?: Maybe<Scalars['Boolean']>;
  /** Primary key for the user. */
  id?: Maybe<Scalars['ID']>;
  /** Custom message to return for this BIN. */
  message?: Maybe<Scalars['String']>;
};

export type BalanceDisruptor = {
  __typename?: 'BalanceDisruptor';
  /** The total negative balance across all pay periods for the user. */
  negativeBalanceAmountCents: Scalars['Int'];
  /** The relevant pay periods for the Balance Disruptor. This includes pay periods with activity since the first negative balance pay period, including any pay periods with a negative balance. */
  payPeriods: PayPeriodConnection;
};


export type BalanceDisruptorPayPeriodsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type BankAccount = ReceivingAccount & {
  __typename?: 'BankAccount';
  /** The account number, last 4 for a debit card. */
  accountNumber: Scalars['String'];
  /** Name of the issuing bank. Warning: This name might not be the name the bank advertises to its clients */
  bankName?: Maybe<Scalars['String']>;
  /** True if user looses promotional benefits by removing this bank account as their primary bank */
  belongsToActivePromotion: Scalars['Boolean'];
  /** True if this is a checking account. */
  checking: Scalars['Boolean'];
  /** Time and date of when the account was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** True if this account is setup to receive payments */
  creditable: Scalars['Boolean'];
  /** Primary key for the account. */
  id: Scalars['ID'];
  /** True if there is a payment method available to make an instant payment to this bank account right now. */
  instantEnabled: Scalars['Boolean'];
  /** The name of the bank for this account, includes card brand for debit cards. */
  name?: Maybe<Scalars['String']>;
  /** The given nickname of the account. */
  nickname?: Maybe<Scalars['String']>;
  /** The first and last name for this account. This may differ from the name of the employee. */
  ownerName?: Maybe<Scalars['String']>;
  /** True if this is the user's primary account of this type. */
  primary: Scalars['Boolean'];
  /** The type of account (BankAccount or DebitCard). */
  receivingAccountType: Scalars['String'];
  /** Return true if this is a masked/blinded view. */
  restricted: Scalars['Boolean'];
  /** The routing number for this bank account. */
  routingNumber?: Maybe<Scalars['String']>;
  /** True if account can receive RTP transfer */
  rtpCreditable: Scalars['Boolean'];
  /** True if this account is enabled for automatic savings. */
  savingsEnabled: Scalars['Boolean'];
  /** Return true if the user needs to 2-factor authenticate before advancing to this account. */
  twoFactorRequired: Scalars['Boolean'];
};

/** The connection type for BankAccount. */
export type BankAccountConnection = {
  __typename?: 'BankAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BankAccountEdge>>>;
  /** A page of BankAccount objects. */
  items: Array<BankAccount>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BankAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type BankAccountEdge = {
  __typename?: 'BankAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BankAccount>;
};

export type BatchDisbursementFile = File & {
  __typename?: 'BatchDisbursementFile';
  /** The originally uploaded data. */
  attachment: Attachment;
  /** The date the file was processed and created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The automatically-generated report (generated as part of asynchronous validation). */
  errorsAttachment?: Maybe<Attachment>;
  /** The ID of the file */
  id: Scalars['ID'];
  /** The original name of the uploaded file. */
  originalFilename: Scalars['String'];
  /** The provider associated with this batch disbursement. */
  provider: Provider;
  /** Reason for batch disbursement. */
  reason: DisbursementReasonCategory;
  /** Employer who uploaded/requested this batch disbursement */
  requester: Employer;
  /** Current status of batch disbursement */
  status: Scalars['String'];
};

/** The connection type for BatchDisbursementFile. */
export type BatchDisbursementFileConnection = {
  __typename?: 'BatchDisbursementFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BatchDisbursementFileEdge>>>;
  /** A page of BatchDisbursementFile objects. */
  items: Array<BatchDisbursementFile>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BatchDisbursementFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type BatchDisbursementFileEdge = {
  __typename?: 'BatchDisbursementFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BatchDisbursementFile>;
};

/** User roster file upload. */
export type BatchOnboardFile = File & {
  __typename?: 'BatchOnboardFile';
  /** The date the file was processed and created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The manager who uploaded the file. */
  creator: User;
  /** The ID of the file */
  id: Scalars['ID'];
  /** The original name of the uploaded file. */
  originalFilename: Scalars['String'];
  /** The status of the upload. */
  status: Scalars['String'];
};

/** The connection type for BatchOnboardFile. */
export type BatchOnboardFileConnection = {
  __typename?: 'BatchOnboardFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BatchOnboardFileEdge>>>;
  /** A page of BatchOnboardFile objects. */
  items: Array<BatchOnboardFile>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BatchOnboardFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type BatchOnboardFileEdge = {
  __typename?: 'BatchOnboardFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BatchOnboardFile>;
};

export type Bill = {
  __typename?: 'Bill';
  /** The biller of this bill. */
  billerName: Scalars['String'];
  /** The date the bill was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Error message for why the bill was rejected */
  errorMessage?: Maybe<Scalars['String']>;
  /** The ID for the bill. */
  id: Scalars['ID'];
  /** The payment associated with the bill */
  payment?: Maybe<EmployeePayment>;
  /** The current status of the bill. */
  status: Scalars['String'];
  /** Total amount of the bill in cents. */
  totalAmountCents: Scalars['Int'];
  /** Currency for total amount of the bill. */
  totalAmountCurrency: Scalars['String'];
  /** The bill id from Papaya Pay */
  vendorBillId: Scalars['String'];
  /** The status of the bill from Papaya Pay */
  vendorStatus: Scalars['String'];
};

/** The connection type for Bill. */
export type BillConnection = {
  __typename?: 'BillConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BillEdge>>>;
  /** A page of Bill objects. */
  items: Array<Bill>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Bill>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type BillEdge = {
  __typename?: 'BillEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Bill>;
};

export type Bonus = {
  __typename?: 'Bonus';
  /** The date the bonus was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID for the bonus. */
  id: Scalars['ID'];
  /** Total amount of bonus in cents. */
  totalAmountCents: Scalars['Int'];
  /** Currency for total amount of payday reserve. */
  totalAmountCurrency: Scalars['String'];
};

/** The connection type for Bonus. */
export type BonusConnection = {
  __typename?: 'BonusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BonusEdge>>>;
  /** A page of Bonus objects. */
  items: Array<Bonus>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Bonus>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type BonusEdge = {
  __typename?: 'BonusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Bonus>;
};

export type CalculatedPayPeriodBalanceDeduction = {
  __typename?: 'CalculatedPayPeriodBalanceDeduction';
  /** The calculated balance deduction amount, if the employee were to make a save or transfer. */
  amountCents: Scalars['Int'];
  /** The pay period the amount is being deducted from. */
  payPeriod: PayPeriod;
};

/** The connection type for CalculatedPayPeriodBalanceDeduction. */
export type CalculatedPayPeriodBalanceDeductionConnection = {
  __typename?: 'CalculatedPayPeriodBalanceDeductionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CalculatedPayPeriodBalanceDeductionEdge>>>;
  /** A page of CalculatedPayPeriodBalanceDeduction objects. */
  items: Array<CalculatedPayPeriodBalanceDeduction>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CalculatedPayPeriodBalanceDeduction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CalculatedPayPeriodBalanceDeductionEdge = {
  __typename?: 'CalculatedPayPeriodBalanceDeductionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CalculatedPayPeriodBalanceDeduction>;
};

export type ComplianceReports = {
  __typename?: 'ComplianceReports';
  /** Evidence that the amount remitted to the DailyPay Account is equal to the amount advanced. */
  cashBalanceReports: PayPeriodConnection;
  /** Return provider accounts with terms acceptance date and first transfer date. */
  directDepositUpdateConsentReports: ProviderAccountConnection;
  /** Evidence that the amount sent to the user, which can be compared to paystubs. */
  paystubReports: PayPeriodConnection;
};


export type ComplianceReportsCashBalanceReportsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  endsAtDate?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type ComplianceReportsDirectDepositUpdateConsentReportsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type ComplianceReportsPaystubReportsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  endsAtDate?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type ConfirmAdvanceAmount = {
  __typename?: 'ConfirmAdvanceAmount';
  /** Error messages for the selected amount if present. */
  errorMessages?: Maybe<Scalars['String']>;
  /** Reason instant transfers are disabled for this employee. */
  instantLockedReason?: Maybe<Scalars['String']>;
  /** True if employee may make an instant transfer. */
  instantUnlocked: Scalars['Boolean'];
  /** True if the selected amount is valid. */
  validAmount: Scalars['Boolean'];
};

/** Autogenerated return type of CreateDirectDepositUpdateFile */
export type CreateDirectDepositUpdateFilePayload = {
  __typename?: 'CreateDirectDepositUpdateFilePayload';
  /** Record of request for direct deposit update (DDU) */
  directDepositUpdateFile: DirectDepositUpdateFile;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Create an off cycle payment to an employee */
export type CreateDisbursementInput = {
  /** The provider account ID that requires payment */
  providerAccountId: Scalars['ID'];
  /** Total amount of payment in cents */
  totalAmountCents: Scalars['Int'];
  /** Reason for payment */
  reason: DisbursementReasonCategory;
  /** Additional notes on the context of the payment */
  notes?: Maybe<Scalars['String']>;
  /** Routing number for new account */
  routingNumber?: Maybe<Scalars['String']>;
  /** Account number */
  accountNumber?: Maybe<Scalars['String']>;
  /** True if bank account is checkings account. False if account is a savings acount. Defaults to true */
  checking?: Maybe<Scalars['Boolean']>;
  /** Bank account (or PBA) id for existing account */
  receivingAccountId?: Maybe<Scalars['ID']>;
  /** Bank account type for existing account, either BankAccount or ProviderBankAccount */
  receivingAccountType?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateDisbursement */
export type CreateDisbursementPayload = {
  __typename?: 'CreateDisbursementPayload';
  /** The newly scheduled disbursement. */
  disbursement?: Maybe<Disbursement>;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Attributes for creating or updating a blog post */
export type CreateManagerInput = {
  /** First name of the new manager. */
  firstName: Scalars['String'];
  /** Last name of the new manager. */
  lastName: Scalars['String'];
  /** Email of the new manager. */
  email: Scalars['String'];
  /** Permissions for new manager. */
  permissions?: Maybe<EmployerPermissions>;
  /** IDs for the companies associated with the new manager. */
  companyIds?: Maybe<Array<Scalars['ID']>>;
  /** IDs for the locations associated with the new manager. */
  locationIds?: Maybe<Array<Scalars['ID']>>;
  /** Phone number of the new manager */
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of CreateManager */
export type CreateManagerPayload = {
  __typename?: 'CreateManagerPayload';
  /** The newly created managers. */
  managers: Array<Manager>;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of CreatePartnerReport */
export type CreatePartnerReportPayload = {
  __typename?: 'CreatePartnerReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

export type CreateRewardInput = {
  /** The employee profile ID for this reward. */
  employeeProfileId: Scalars['ID'];
  /** Total amount of reward in cents. */
  totalAmountCents: Scalars['Int'];
  /** Additional notes on the context of the reward. */
  notes?: Maybe<Scalars['String']>;
  /** Reason for reward */
  reason?: Maybe<RewardReason>;
};

/** Autogenerated return type of CreateReward */
export type CreateRewardPayload = {
  __typename?: 'CreateRewardPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

export type CurrentPayPeriodSummary = {
  __typename?: 'CurrentPayPeriodSummary';
  /** Total available balance across all pay periods. */
  availableBalanceCents: Scalars['Int'];
  /** When the last invoice was created across all pay periods. */
  lastShiftReportedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Total amount of unprocessed bonuses for this employee. */
  totalBonusAmountCents: Scalars['Int'];
};

export type CustomizationProfile = {
  __typename?: 'CustomizationProfile';
  /** Primary color code for provider. Example: ff0000. */
  primaryColor?: Maybe<Scalars['String']>;
  /** Secondary color code for provider. Example: 00ff00 */
  secondaryColor?: Maybe<Scalars['String']>;
};

/** Date range input to filter resource by */
export type DateRangeInput = {
  beginDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
};

export type DebitCard = ReceivingAccount & {
  __typename?: 'DebitCard';
  /** The account number, last 4 for a debit card. */
  accountNumber: Scalars['String'];
  /** Name of the bank that issued this debit card */
  bankName?: Maybe<Scalars['String']>;
  /** True if this debit card is part of an active promotion through which the user can get free transfers. */
  belongsToActivePromotion: Scalars['Boolean'];
  /** Custom message to return for this BIN. */
  binMessage?: Maybe<BinMessage>;
  /** True if this is the user's primary account of this type. */
  checking?: Maybe<Scalars['Boolean']>;
  /** Time and date of when the account was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The expiration month of this debit card */
  expMonth: Scalars['String'];
  /** The expiration year of this debit card */
  expYear: Scalars['String'];
  /** Primary key for the account. */
  id: Scalars['ID'];
  /** True if there is a rail available to make a payment to this debit card right now. */
  instantEnabled: Scalars['Boolean'];
  /** The name of the bank for this account, includes card brand for debit cards. */
  name?: Maybe<Scalars['String']>;
  /** The given nickname of the account. */
  nickname?: Maybe<Scalars['String']>;
  /** The first and last name for this account. This may differ from the name of the employee. */
  ownerName?: Maybe<Scalars['String']>;
  /** True if this is the user's primary account of this type. */
  primary: Scalars['Boolean'];
  /** The type of account (BankAccount or DebitCard). */
  receivingAccountType: Scalars['String'];
  /** Return true if this is a masked/blinded view. */
  restricted: Scalars['Boolean'];
  /** The status of the debit card. */
  status: Scalars['String'];
  /** Return true if the user needs to 2-factor authenticate before advancing to this account. */
  twoFactorRequired: Scalars['Boolean'];
};

/** The connection type for DebitCard. */
export type DebitCardConnection = {
  __typename?: 'DebitCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DebitCardEdge>>>;
  /** A page of DebitCard objects. */
  items: Array<DebitCard>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DebitCard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DebitCardEdge = {
  __typename?: 'DebitCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DebitCard>;
};

/** A direct deposit update file download. */
export type DirectDepositUpdateFile = {
  __typename?: 'DirectDepositUpdateFile';
  /** A link to the exported direct deposit update. */
  attachment?: Maybe<Attachment>;
  /** The date the file was downloaded. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The manager who downloaded the file. */
  creator: User;
  /** The ID of the direct deposit update file. */
  id: Scalars['ID'];
};

/** The connection type for DirectDepositUpdateFile. */
export type DirectDepositUpdateFileConnection = {
  __typename?: 'DirectDepositUpdateFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DirectDepositUpdateFileEdge>>>;
  /** A page of DirectDepositUpdateFile objects. */
  items: Array<DirectDepositUpdateFile>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DirectDepositUpdateFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The number of employees to update. */
  pendingUpdateCount?: Maybe<Scalars['Int']>;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DirectDepositUpdateFileEdge = {
  __typename?: 'DirectDepositUpdateFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DirectDepositUpdateFile>;
};

export type Disbursement = {
  __typename?: 'Disbursement';
  /** True if the current employer can approve this disbursement. */
  canApprove: Scalars['Boolean'];
  /** Date disbursement was created and scheduled */
  createdAt: Scalars['ISO8601DateTime'];
  /** Date disbursement payment is scheduled or when it was actually paid. Blank if pending approval. */
  disbursementReceivedOn?: Maybe<Scalars['ISO8601DateTime']>;
  /** Dollar amount of fees in cents */
  feeAmountCents: Scalars['Int'];
  /** Primary key for this disbursement */
  id: Scalars['ID'];
  /** Miscellaneous notes about off cycle payment */
  notes?: Maybe<Scalars['String']>;
  /** ID of related partner invoice */
  partnerInvoiceId?: Maybe<Scalars['ID']>;
  /** User account payment was made towards */
  providerAccount: ProviderAccount;
  /** Reason behind off cycle payment */
  reason: DisbursementReasonCategory;
  /** Date of expected repayment for off cycle payment */
  repaymentExpectedOn: Scalars['ISO8601DateTime'];
  /** Employer who requested disbursement */
  requester?: Maybe<Employer>;
  /** Current status of off cycle payment */
  status: Scalars['String'];
  /** Total dollar amount in cents */
  totalAmountCents: Scalars['Int'];
  /**
   * User account payment was made towards
   * @deprecated Deprecated in favor of provider_account field with same value
   */
  user: ProviderAccount;
  /** The bank account receiving the funds for this payment. */
  userBankAccount: ReceivingAccount;
};

/** The connection type for Disbursement. */
export type DisbursementConnection = {
  __typename?: 'DisbursementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DisbursementEdge>>>;
  /** A page of Disbursement objects. */
  items: Array<Disbursement>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Disbursement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DisbursementEdge = {
  __typename?: 'DisbursementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Disbursement>;
};

export enum DisbursementReasonCategory {
  /** bonus payment */
  Bonus = 'BONUS',
  /** direct deposit replacement */
  DirectDepositReplacement = 'DIRECT_DEPOSIT_REPLACEMENT',
  /** paper check replacement */
  PapercheckReplacement = 'PAPERCHECK_REPLACEMENT',
  /** payment for missing PTO hours */
  MissingHoursPto = 'MISSING_HOURS_PTO',
  /** payment for work to an employee who has been terminated */
  Termination = 'TERMINATION',
  /** tips payment */
  Tips = 'TIPS',
  /** payment for reason outside of available reasons */
  Other = 'OTHER'
}

export type Employee = {
  __typename?: 'Employee';
  /** Time at which the account was challenged by Castle. */
  accountChallengedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Latest active negative balance payoff entry, if any, when available balance is $0 */
  activePayoffEntry?: Maybe<PayoffEntry>;
  /** Address line 1 for the user. */
  address1?: Maybe<Scalars['String']>;
  /** Address line 2 for the user. */
  address2?: Maybe<Scalars['String']>;
  /** All announcements */
  announcements?: Maybe<AnnouncementConnection>;
  /** Returns promotion name or nil */
  availableManualNextPromotion?: Maybe<Scalars['String']>;
  /** Returns promotion name or nil */
  availableManualNowPromotion?: Maybe<Scalars['String']>;
  /** Information related to the negative balance of the user. Null if the user does not have a negative balance. */
  balanceDisruptor?: Maybe<BalanceDisruptor>;
  /** The bills the user has. */
  bills?: Maybe<BillConnection>;
  /** Given a total transfer or savings amount, calculates the balance deducted from each advanceable pay period. */
  calculatedPayPeriodBalanceDeductions: CalculatedPayPeriodBalanceDeductionConnection;
  /** The city for the user. */
  city?: Maybe<Scalars['String']>;
  /** The completed and failed payments to the employee. */
  completedEmployeePayments?: Maybe<EmployeePaymentConnection>;
  /** Summary of all current pay periods. */
  currentPayPeriodSummary: CurrentPayPeriodSummary;
  /** Current pay periods for this employee. Project one using the schedule if none exist. */
  currentPayPeriods: PayPeriodConnection;
  /** Custom instructions for SSO. */
  customSsoInstructions?: Maybe<Scalars['String']>;
  /** The user owned debit card(s). */
  debitCards?: Maybe<DebitCardConnection>;
  /** Returns whether the user has access to the Direct Savings product. */
  directSavingsEnabled: Scalars['Boolean'];
  /** The returns true if early deposit is enabled for the primary account. */
  earlyDepositEnabled?: Maybe<Scalars['Boolean']>;
  /** The email account of the user */
  email?: Maybe<Scalars['String']>;
  /** Time at which the employee last verified their email. */
  emailVerifiedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Return notification settings for this employee. */
  employeeNotificationSettings: EmployeeNotificationSettings;
  employeePayment?: Maybe<EmployeePayment>;
  /** The completed, failed, and pending payments to the employee, sorted by age. */
  employeePayments?: Maybe<EmployeePaymentConnection>;
  /** The provider scoped employee profile for the employee. */
  employeeProfileForProvider?: Maybe<EmployeeProfile>;
  /** A random financial tip */
  financialTip?: Maybe<FinancialTip>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']>;
  /** Time at which the first transfer was taken. */
  firstTransferAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Free transfer promotions the employee is eligible for. */
  freeTransferPromotions: FreeTransferPromotionConnection;
  /** True if the user has a placeholder email */
  hasPlaceholderEmail: Scalars['Boolean'];
  /** Primary key for the user. */
  id: Scalars['ID'];
  /** True if user is eligible for Friday. */
  isFridayEligible: Scalars['Boolean'];
  /** True if user is enrolled in Friday. */
  isFridayEnrolled: Scalars['Boolean'];
  /** True if user is eligible for Friday waitlist. */
  isFridayWaitlistAvailable: Scalars['Boolean'];
  /** User identifier used for analytics. */
  knownTrackingId: Scalars['String'];
  /** The two character locale for the user. Default EN. */
  languagePreference: LanguagePreference;
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']>;
  /** All active notifications */
  notifications?: Maybe<NotificationConnection>;
  /** Returns whether the employee is on a payment plan */
  onPaymentPlan: Scalars['Boolean'];
  /** JWT token to access the Papaya Pay SDK */
  papayaSdkAccessToken: Scalars['String'];
  /** Return the given pay period by ID. */
  payPeriod: PayPeriod;
  /** Return the pay periods for this account. */
  payPeriods?: Maybe<PayPeriodConnection>;
  /** The pending payments to the employee. */
  pendingEmployeePayments?: Maybe<EmployeePaymentConnection>;
  /** The obfuscated telephone number for the user. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Time at which the employee last verified their phone. */
  phoneVerifiedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Return provider accounts for this employee. */
  providerAccounts: EmployeeProviderAccountConnection;
  /** The DailyPay bank account to use for direct deposit. */
  providerBankAccount?: Maybe<BankAccount>;
  /** Providers associated with this user. */
  providers: ProviderConnection;
  /** Return a pull advance with fee information. */
  pullAdvance: PullAdvance;
  /** Number of transfers until the employee gets a free transfer. */
  punchCard?: Maybe<PunchCard>;
  /** Returns whether the employee is qualified to review the mobile app. */
  qualifiesForReview: Scalars['Boolean'];
  /** Returns the lastest code used by the employee to send a referral */
  referralCode?: Maybe<Scalars['String']>;
  /** Email of the person that referred the employee */
  referrerEmail?: Maybe<Scalars['String']>;
  /** The rewards for the employee. */
  rewards: RewardConnection;
  /** Returns whether the user has access to the Roundup Savings product. */
  roundupSavingsEnabled: Scalars['Boolean'];
  /** All pay periods where the user will be expecting a settlement for at the end of their pay period. */
  settlementOwedPayPeriods?: Maybe<PayPeriodConnection>;
  /** Returns whether the user is required to sign in with SSO. */
  ssoRequired: Scalars['Boolean'];
  /** The state/subregion for the user's address */
  state?: Maybe<Scalars['String']>;
  /** The status of this employee. */
  status: Scalars['String'];
  /** True if the user has accepted the terms of service */
  termsAccepted: Scalars['Boolean'];
  /** The date this employee accepted terms. */
  termsAcceptedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The user owned bank account(s). */
  userBankAccounts?: Maybe<BankAccountConnection>;
  /** The returns true if the chime_cohort_user flipper is on for the user. */
  userEarlyPayFlipperEnabled: Scalars['Boolean'];
  /** The status of the user account across all providers. */
  userStatus: Scalars['String'];
  /** True if user is active on the wisely app. */
  usingWisely: Scalars['Boolean'];
  /** The zip code for the user. */
  zip?: Maybe<Scalars['String']>;
};


export type EmployeeAnnouncementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EmployeeBillsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EmployeeCalculatedPayPeriodBalanceDeductionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  totalAmountCents: Scalars['Int'];
};


export type EmployeeCompletedEmployeePaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeCurrentPayPeriodsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeDebitCardsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  availableOnly?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeEmployeePaymentArgs = {
  id: Scalars['ID'];
};


export type EmployeeEmployeePaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeEmployeeProfileForProviderArgs = {
  providerId: Scalars['Int'];
};


export type EmployeeFreeTransferPromotionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EmployeeNotificationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EmployeePapayaSdkAccessTokenArgs = {
  amountCents: Scalars['Int'];
};


export type EmployeePayPeriodArgs = {
  id: Scalars['ID'];
};


export type EmployeePayPeriodsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeePendingEmployeePaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeProviderAccountsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  providerAccountStatus?: Maybe<Scalars['String']>;
};


export type EmployeeProvidersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeRewardsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeSettlementOwedPayPeriodsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeUserBankAccountsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type EmployeeAdvance = {
  __typename?: 'EmployeeAdvance';
  /** What type of advance this is (example: pull). */
  advanceType: Scalars['String'];
  /** Return advances associated with this payment. */
  advances: AdvanceConnection;
  /** Return bonuses associated with this payment. */
  bonuses: BonusConnection;
  /** Dollar amount of fees in cents for this payment and pay period. */
  feeAmountCents: Scalars['Int'];
  /** ID for this pay_period-payment. Formatted as pay_period_id-payment_id so split payments are unique. */
  id: Scalars['ID'];
  /** Returns whether the payment was for a savings product. */
  isSavings: Scalars['Boolean'];
  /** Dollar amount in cents for this payment and pay period (excluding fees). */
  payPeriodAmountCents: Scalars['Int'];
  /** Return payday reserves associated with this payment. */
  paydayReserves?: Maybe<PaydayReserveConnection>;
  /** Primary key for the payment. */
  paymentId: Scalars['ID'];
  /** How this payment was sent. Examples: ACH, Instant, etc. */
  paymentMethod: Scalars['String'];
  /** The status of this payment. */
  paymentStatus: Scalars['String'];
  /** Is this payment a credit or debit. */
  paymentType: Scalars['String'];
  /** The date the payment was processed. */
  processedOn: Scalars['ISO8601Date'];
  /** The account receiving the funds for this payment. May be a bank account or a debit card. */
  receivingAccount?: Maybe<ReceivingAccount>;
  /** Payments from other pay periods related to this one. */
  relatedPayments?: Maybe<RelatedPayments>;
  /** Return rewards associated with this payment. */
  rewards: RewardConnection;
  /** Return settlements associated with this payment. */
  settlements: SettlementConnection;
  /** Total advance amount */
  totalAdvancedAmountCents: Scalars['Int'];
  totalAdvancedAmountFromNonSettledPayPeriods: Scalars['Int'];
  /** Dollar amount in cents for this payment across all pay periods (excluding fees). */
  totalAmountCents: Scalars['Int'];
  /** Dollar amount of fees in cents for this payment across all pay periods. */
  totalFeeAmountCents: Scalars['Int'];
  /** A user specified note for this transfer. */
  transferReason?: Maybe<TransferReason>;
};


export type EmployeeAdvanceAdvancesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeAdvanceBonusesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeAdvancePaydayReservesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeAdvanceRewardsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeAdvanceSettlementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for EmployeeAdvance. */
export type EmployeeAdvanceConnection = {
  __typename?: 'EmployeeAdvanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeAdvanceEdge>>>;
  /** A page of EmployeeAdvance objects. */
  items: Array<EmployeeAdvance>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmployeeAdvance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeAdvanceEdge = {
  __typename?: 'EmployeeAdvanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeAdvance>;
};

/** Notification settings for this employee. */
export type EmployeeNotificationSettings = {
  __typename?: 'EmployeeNotificationSettings';
  /** True if balance email alerts are enabled. */
  balanceUpdateAlertEmailSubscribed: Scalars['Boolean'];
  /** True if balance push notifications are enabled. */
  balanceUpdateAlertPushSubscribed: Scalars['Boolean'];
  /** True if balance text alerts are enabled. */
  balanceUpdateAlertTextSubscribed: Scalars['Boolean'];
  /** True if marketing and promotional emails are enabled. */
  emailSubscribed: Scalars['Boolean'];
  /** True if end of pay period statements are enabled. */
  payPeriodSubscribed: Scalars['Boolean'];
  /** True if early transfer statements are enabled. */
  paymentSubscribed: Scalars['Boolean'];
};

export type EmployeePayment = {
  __typename?: 'EmployeePayment';
  /** Return advances associated with this payment. */
  advances: AdvanceConnection;
  /** Return bonuses associated with this payment. */
  bonuses: BonusConnection;
  /** Dollar amount of fees in cents for this payment and pay period. */
  feeAmountCents: Scalars['Int'];
  /** ID for this pay_period-payment. Formatted as pay_period_id-payment_id so split payments are unique. */
  id: Scalars['ID'];
  /** Returns whether the payment was for a savings product. */
  isSavings: Scalars['Boolean'];
  /** Dollar amount in cents for this payment and pay period (excluding fees). */
  payPeriodAmountCents: Scalars['Int'];
  /** Return payday reserves associated with this payment. */
  paydayReserves?: Maybe<PaydayReserveConnection>;
  /** Primary key for the payment. */
  paymentId: Scalars['ID'];
  /** How this payment was sent. Examples: ACH, Instant, etc. */
  paymentMethod: Scalars['String'];
  /** The status of this payment. */
  paymentStatus: Scalars['String'];
  /** Is this payment a credit or debit. */
  paymentType: Scalars['String'];
  /** The date the payment was processed. */
  processedOn: Scalars['ISO8601Date'];
  /** The account receiving the funds for this payment. May be a bank account or a debit card. */
  receivingAccount?: Maybe<ReceivingAccount>;
  /** Payments from other pay periods related to this one. */
  relatedPayments?: Maybe<RelatedPayments>;
  /** Return rewards associated with this payment. */
  rewards: RewardConnection;
  /** Return settlements associated with this payment. */
  settlements: SettlementConnection;
  totalAdvancedAmountFromNonSettledPayPeriods: Scalars['Int'];
  /** Dollar amount in cents for this payment across all pay periods (excluding fees). */
  totalAmountCents: Scalars['Int'];
  /** Dollar amount of fees in cents for this payment across all pay periods. */
  totalFeeAmountCents: Scalars['Int'];
  /** A user specified note for this transfer. */
  transferReason?: Maybe<TransferReason>;
};


export type EmployeePaymentAdvancesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeePaymentBonusesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeePaymentPaydayReservesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeePaymentRewardsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeePaymentSettlementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for EmployeePayment. */
export type EmployeePaymentConnection = {
  __typename?: 'EmployeePaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeePaymentEdge>>>;
  /** A page of EmployeePayment objects. */
  items: Array<EmployeePayment>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmployeePayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeePaymentEdge = {
  __typename?: 'EmployeePaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EmployeePayment>;
};

export type EmployeeProfile = {
  __typename?: 'EmployeeProfile';
  /** Employee bank account confirmed, and direct deposit not canceled */
  confirmedAndNotCanceled: Scalars['Boolean'];
  /** DDU Status for the employee profile. */
  dduStatus?: Maybe<Scalars['String']>;
  /** Return disbursements associated with this employee. */
  disbursements: DisbursementConnection;
  /** The employee DPA is confirmed in the partner payroll system */
  dpaOnFile: Scalars['Boolean'];
  /** The employee associated with this profile. */
  employee: Employee;
  /** The location for this employee. */
  employeeLocation?: Maybe<ProviderLocation>;
  /** Time when employee enrolled in payroll extender */
  enrolledInPayrollExtenderAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The provider assigned employee ID(s) for this account. */
  externalIds: Array<ExternalId>;
  /** Primary key for this employee profile. */
  id: Scalars['ID'];
  /**
   * The location name for this account (normally city and state).
   * @deprecated replacing with employee_location field
   */
  location?: Maybe<Scalars['String']>;
  /** Time a user opted into Friday */
  optedFridayWaitlistAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date this employee was canceled. */
  partnerCanceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Pay groups to which the employee belongs */
  payGroups: Array<Scalars['String']>;
  /** Return given provider account associated with this employee. */
  providerAccount: ProviderAccount;
  /** Return provider accounts associated with this employee. */
  providerAccounts: ProviderAccountConnection;
};


export type EmployeeProfileDisbursementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeProfileProviderAccountArgs = {
  id: Scalars['ID'];
};


export type EmployeeProfileProviderAccountsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for EmployeeProfile. */
export type EmployeeProfileConnection = {
  __typename?: 'EmployeeProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeProfileEdge>>>;
  /** A page of EmployeeProfile objects. */
  items: Array<EmployeeProfile>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmployeeProfile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeProfileEdge = {
  __typename?: 'EmployeeProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeProfile>;
};

export type EmployeeProviderAccount = {
  __typename?: 'EmployeeProviderAccount';
  /** Automatic savings amount in cents. */
  fixedDeductionAmountCents: Scalars['Int'];
  /** Primary key for the provider account. */
  id: Scalars['ID'];
  /** Dates next payday payments are scheduled. */
  nextPaydayDates?: Maybe<Array<Scalars['ISO8601Date']>>;
  /** Dates next payroll extender payments are scheduled. */
  nextPayrollExtenderDates?: Maybe<Array<Scalars['ISO8601Date']>>;
  /** The pay group associated with this provider account. */
  payGroup: Scalars['String'];
  /** The provider associated with the provider account. */
  provider: Provider;
  /** The status of the provider account. */
  providerAccountStatus: Scalars['String'];
  /** Return if provider has enabled payroll extender. */
  providerPayrollExtenderEnabled: Scalars['Boolean'];
  /** True if provider account has access to rolling balance withdrawals. */
  rollingBalanceEnabled: Scalars['Boolean'];
  /** Return the date user enabled payroll extender. */
  userPayrollExtenderEnabledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The wage type for this provider account. */
  wageType: Scalars['String'];
};

/** The connection type for EmployeeProviderAccount. */
export type EmployeeProviderAccountConnection = {
  __typename?: 'EmployeeProviderAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeProviderAccountEdge>>>;
  /** A page of EmployeeProviderAccount objects. */
  items: Array<EmployeeProviderAccount>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmployeeProviderAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeProviderAccountEdge = {
  __typename?: 'EmployeeProviderAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeProviderAccount>;
};

export type EmployeeSettlement = {
  __typename?: 'EmployeeSettlement';
  /** Return advances associated with this payment. */
  advances: AdvanceConnection;
  /** Return bonuses associated with this payment. */
  bonuses: BonusConnection;
  /** Dollar amount of fees in cents for this payment and pay period. */
  feeAmountCents: Scalars['Int'];
  /** ID for this pay_period-payment. Formatted as pay_period_id-payment_id so split payments are unique. */
  id: Scalars['ID'];
  /** Returns whether the payment was for a savings product. */
  isSavings: Scalars['Boolean'];
  /** Dollar amount in cents for this payment and pay period (excluding fees). */
  payPeriodAmountCents: Scalars['Int'];
  /** Return payday reserves associated with this payment. */
  paydayReserves?: Maybe<PaydayReserveConnection>;
  /** Primary key for the payment. */
  paymentId: Scalars['ID'];
  /** How this payment was sent. Examples: ACH, Instant, etc. */
  paymentMethod: Scalars['String'];
  /** The status of this payment. */
  paymentStatus: Scalars['String'];
  /** Is this payment a credit or debit. */
  paymentType: Scalars['String'];
  /** The date the payment was processed. */
  processedOn: Scalars['ISO8601Date'];
  /** The account receiving the funds for this payment. May be a bank account or a debit card. */
  receivingAccount?: Maybe<ReceivingAccount>;
  /** Payments from other pay periods related to this one. */
  relatedPayments?: Maybe<RelatedPayments>;
  /** Return rewards associated with this payment. */
  rewards: RewardConnection;
  /** Return settlements associated with this payment. */
  settlements: SettlementConnection;
  totalAdvancedAmountFromNonSettledPayPeriods: Scalars['Int'];
  /** Dollar amount in cents for this payment across all pay periods (excluding fees). */
  totalAmountCents: Scalars['Int'];
  /** Dollar amount of fees in cents for this payment across all pay periods. */
  totalFeeAmountCents: Scalars['Int'];
  /** A user specified note for this transfer. */
  transferReason?: Maybe<TransferReason>;
};


export type EmployeeSettlementAdvancesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeSettlementBonusesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeSettlementPaydayReservesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeSettlementRewardsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type EmployeeSettlementSettlementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for EmployeeSettlement. */
export type EmployeeSettlementConnection = {
  __typename?: 'EmployeeSettlementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeSettlementEdge>>>;
  /** A page of EmployeeSettlement objects. */
  items: Array<EmployeeSettlement>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmployeeSettlement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeSettlementEdge = {
  __typename?: 'EmployeeSettlementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeSettlement>;
};

export type Employer = {
  __typename?: 'Employer';
  /** Lookup locations associated with this employer for this provider. Return all locations if no scoping. */
  associatedLocations: ProviderLocationConnection;
  /** Return the provider selected in the context. */
  currentProvider: Provider;
  /** Custom instructions for SSO. */
  customSsoInstructions?: Maybe<Scalars['String']>;
  /** The email of the user. */
  email?: Maybe<Scalars['String']>;
  /** Return notification settings for this employer. */
  employerNotificationSettings: EmployerNotificationSettings;
  /** Options and fees for rewards on this employer. */
  employerRewardBudget: EmployerRewardBudget;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']>;
  /** Primary key for the user. */
  id: Scalars['ID'];
  /** The two character locale for the user. Default EN. */
  languagePreference: LanguagePreference;
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']>;
  /** The role to assign for this employer. */
  permissions: EmployerPermissions;
  /** The obfuscated telephone number for the user. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Providers associated with this user. */
  providers: ProviderConnection;
  /** Work phone number for this employer. This may include an extension, so may be more than 10 digits. */
  workPhoneNumber?: Maybe<Scalars['String']>;
};


export type EmployerAssociatedLocationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type EmployerProvidersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for Employer. */
export type EmployerConnection = {
  __typename?: 'EmployerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployerEdge>>>;
  /** A page of Employer objects. */
  items: Array<Employer>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Employer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployerEdge = {
  __typename?: 'EmployerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Employer>;
};

/** Notification settings for this employer. */
export type EmployerNotificationSettings = {
  __typename?: 'EmployerNotificationSettings';
  /** Boolean to enable reminder email to activate or cancel currently pending users */
  actionRequiredEmailSubscribed: Scalars['Boolean'];
  /** Boolean to enable reminder email to upload earnings */
  earningsReminderSubscribed: Scalars['Boolean'];
  /** Boolean to enable off cycle disbursement approval emails. */
  offCycleDisbursementApprovalSubscribed: Scalars['Boolean'];
  /** Boolean to enable reminder email to upload payroll journal */
  payrollJournalReminderSubscribed: Scalars['Boolean'];
};

export enum EmployerPermissions {
  /** Role for managers that may activate and deactivate employees. */
  ActivationsPermissions = 'ACTIVATIONS_PERMISSIONS',
  /** Role for managers that may update earnings. */
  EarningsPermissions = 'EARNINGS_PERMISSIONS',
  /** Role for operating managers able to disburse rewards */
  OperatingManager = 'OPERATING_MANAGER',
  /** Role for managers with all permissions but not all locations */
  LocalAdmin = 'LOCAL_ADMIN',
  /** Role for managers with all permissions. */
  FullPermissions = 'FULL_PERMISSIONS',
  /** Role for managers that may not make changes. */
  ViewOnly = 'VIEW_ONLY'
}

export type EmployerRewardBudget = {
  __typename?: 'EmployerRewardBudget';
  /** The employer for this budget. */
  employer: Employer;
  /** The expected approvers for this budget. */
  expectedApprovers?: Maybe<Array<Employer>>;
  /** Primary key for the reward budget. NULL if there is no budget set. */
  id?: Maybe<Scalars['ID']>;
  /** The total amount (monthly) remaining for this budget. */
  remainingAmountCents: Scalars['Int'];
  /** The total amount (monthly) for this budget. */
  totalAmountCents: Scalars['Int'];
};

/** The connection type for EmployerRewardBudget. */
export type EmployerRewardBudgetConnection = {
  __typename?: 'EmployerRewardBudgetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployerRewardBudgetEdge>>>;
  /** A page of EmployerRewardBudget objects. */
  items: Array<EmployerRewardBudget>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmployerRewardBudget>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployerRewardBudgetEdge = {
  __typename?: 'EmployerRewardBudgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EmployerRewardBudget>;
};

/** Autogenerated return type of EnableSmsOnboarding */
export type EnableSmsOnboardingPayload = {
  __typename?: 'EnableSmsOnboardingPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of ExportCashBalanceReport */
export type ExportCashBalanceReportPayload = {
  __typename?: 'ExportCashBalanceReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of ExportDduConsentReport */
export type ExportDduConsentReportPayload = {
  __typename?: 'ExportDduConsentReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of ExportPayrollExtenderReport */
export type ExportPayrollExtenderReportPayload = {
  __typename?: 'ExportPayrollExtenderReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of ExportPaystubReport */
export type ExportPaystubReportPayload = {
  __typename?: 'ExportPaystubReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of ExportPresettlementExclusionReport */
export type ExportPresettlementExclusionReportPayload = {
  __typename?: 'ExportPresettlementExclusionReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of ExportRewardsReport */
export type ExportRewardsReportPayload = {
  __typename?: 'ExportRewardsReportPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Provider assigned employee ID for this account. */
export type ExternalId = {
  __typename?: 'ExternalId';
  /** The provider assigned ID */
  id?: Maybe<Scalars['String']>;
  /** What kind of ID this is (examples: external_id, alternative_id) */
  kind: Scalars['String'];
  /** True if this is the primary external ID for this account. */
  primary?: Maybe<Scalars['Boolean']>;
};

/** A feature toggle. */
export type Feature = {
  __typename?: 'Feature';
  name: Scalars['String'];
};

/** The connection type for Feature. */
export type FeatureConnection = {
  __typename?: 'FeatureConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FeatureEdge>>>;
  /** A page of Feature objects. */
  items: Array<Feature>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Feature>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FeatureEdge = {
  __typename?: 'FeatureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Feature>;
};

export type File = {
  /** The date the file was processed and created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the file */
  id: Scalars['ID'];
  /** The original name of the uploaded file. */
  originalFilename: Scalars['String'];
};

/** Generic file upload */
export type FileUploadInput = {
  /** File to upload */
  attachment: Scalars['Upload'];
};

export enum FinalPay {
  /** Final pay is via direct deposit on file. */
  DirectDepositOnly = 'DIRECT_DEPOSIT_ONLY',
  /** Final pay is only via a paper check and DailyPay advance amount needs to be deducted. */
  PaperCheckOnly = 'PAPER_CHECK_ONLY',
  /** Final pay is split between paper check to worker and direct deposit to DailyPay account. */
  PaperCheckAndDirectDeposit = 'PAPER_CHECK_AND_DIRECT_DEPOSIT',
  /** Final pay is only via a paper check and DailyPay needs to recoup the advance amount directly from the end user. */
  PaperCheckNoDeduction = 'PAPER_CHECK_NO_DEDUCTION'
}

export type FinancialTip = {
  __typename?: 'FinancialTip';
  /** The author of the tip */
  author?: Maybe<Scalars['String']>;
  /** The text of the tip */
  body: Scalars['String'];
  /** The ID of the tip */
  id: Scalars['String'];
};

export type FreeTransferPromotion = {
  __typename?: 'FreeTransferPromotion';
  /** The datetime this promotion expires at. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** This promotion gives free next day */
  forManualNext: Scalars['Boolean'];
  /** This promotion gives is for free instant */
  forManualNow: Scalars['Boolean'];
  /** The ID for the promotion. */
  id: Scalars['ID'];
  /** Returns promotion name */
  name: Scalars['String'];
  /** This is the notification message of this promotion */
  notificationMessage?: Maybe<Scalars['String']>;
  /** This is the notification title for this promotion */
  notificationTitle?: Maybe<Scalars['String']>;
  /** True if we want to let the employee know about this promotion */
  notifyEmployee: Scalars['Boolean'];
};

/** The connection type for FreeTransferPromotion. */
export type FreeTransferPromotionConnection = {
  __typename?: 'FreeTransferPromotionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FreeTransferPromotionEdge>>>;
  /** A page of FreeTransferPromotion objects. */
  items: Array<FreeTransferPromotion>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FreeTransferPromotion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FreeTransferPromotionEdge = {
  __typename?: 'FreeTransferPromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FreeTransferPromotion>;
};

/** Autogenerated return type of GenerateBatchDisbursementUploadUrl */
export type GenerateBatchDisbursementUploadUrlPayload = {
  __typename?: 'GenerateBatchDisbursementUploadUrlPayload';
  /** Post URL used to upload batch disbursement file to S3 */
  batchDisbursementUploadUrl: Scalars['String'];
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of GenerateBatchOnboardUrl */
export type GenerateBatchOnboardUrlPayload = {
  __typename?: 'GenerateBatchOnboardUrlPayload';
  /** File download url for batch onboard */
  batchOnboardUrl: Scalars['String'];
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of GenerateDduReportUrl */
export type GenerateDduReportUrlPayload = {
  __typename?: 'GenerateDduReportUrlPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** File download url for ddu report */
  reportUrl: Scalars['String'];
};

/** Autogenerated return type of GeneratePartnerReportUrl */
export type GeneratePartnerReportUrlPayload = {
  __typename?: 'GeneratePartnerReportUrlPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** File download url for partner report */
  reportUrl: Scalars['String'];
};

/** Autogenerated return type of GeneratePayrollAnomalyReportUrl */
export type GeneratePayrollAnomalyReportUrlPayload = {
  __typename?: 'GeneratePayrollAnomalyReportUrlPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** File download url for payroll anomaly report */
  reportUrl: Scalars['String'];
};

/** Autogenerated return type of GenerateRewardsReportUrl */
export type GenerateRewardsReportUrlPayload = {
  __typename?: 'GenerateRewardsReportUrlPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** File download url for rewards report */
  reportUrl: Scalars['String'];
};

/** Previously uploaded gross earnings file. */
export type GrossEarningsTransmissionFile = File & {
  __typename?: 'GrossEarningsTransmissionFile';
  /** The original gross earnings file, hosted on S3 */
  attachment?: Maybe<Attachment>;
  /** The date the file was processed and created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the file */
  id: Scalars['ID'];
  /** The manager who performed the upload. */
  manager: Manager;
  /** The original name of the uploaded file. */
  originalFilename: Scalars['String'];
  /** The status of the transmission */
  status: Scalars['String'];
};

/** The connection type for GrossEarningsTransmissionFile. */
export type GrossEarningsTransmissionFileConnection = {
  __typename?: 'GrossEarningsTransmissionFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GrossEarningsTransmissionFileEdge>>>;
  /** A page of GrossEarningsTransmissionFile objects. */
  items: Array<GrossEarningsTransmissionFile>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GrossEarningsTransmissionFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GrossEarningsTransmissionFileEdge = {
  __typename?: 'GrossEarningsTransmissionFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GrossEarningsTransmissionFile>;
};



export enum LanguagePreference {
  /** English. */
  En = 'EN',
  /** Spanish. */
  Es = 'ES'
}

/** An employer for a given provider. */
export type Manager = {
  __typename?: 'Manager';
  /** The email of the employer. */
  email?: Maybe<Scalars['String']>;
  /** Employer may be employed by a provider or company. */
  employableType: Scalars['String'];
  /** ID of the user (employer) associated with this manager */
  employerId: Scalars['ID'];
  /** True if user is an ether account */
  ether: Scalars['Boolean'];
  /** The first name of the employer. */
  firstName?: Maybe<Scalars['String']>;
  /** Primary key for this employment. */
  id: Scalars['ID'];
  /** The last name of the employer. */
  lastName?: Maybe<Scalars['String']>;
  /** Locations this employment has access to. Empty array implies access to all locations */
  locations: ProviderLocationConnection;
  /** Pay group to which the employer belongs */
  payGroup: Scalars['String'];
  /** The role to assign for this manager. */
  permissions: EmployerPermissions;
  /** Employer status. */
  status: Scalars['String'];
};


/** An employer for a given provider. */
export type ManagerLocationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for Manager. */
export type ManagerConnection = {
  __typename?: 'ManagerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ManagerEdge>>>;
  /** A page of Manager objects. */
  items: Array<Manager>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Manager>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ManagerEdge = {
  __typename?: 'ManagerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Manager>;
};

export enum MetabaseDashboardToken {
  /** Return the ID for the usage dashboard. */
  Usage = 'USAGE',
  /** Return the ID for the enrollment dashboard. */
  Enrollment = 'ENROLLMENT'
}

export type Notification = {
  __typename?: 'Notification';
  /** The text displayed for the action link. */
  actionText?: Maybe<Scalars['String']>;
  /** The body message of the modal */
  body?: Maybe<Scalars['String']>;
  /** The text on the call to action on the modal. */
  callToActionText?: Maybe<Scalars['String']>;
  /** The title to be displayed on the notification widget and modal. */
  title: Scalars['String'];
  /** An enum that indicates the type of notification. */
  type: NotificationType;
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A page of Notification objects. */
  items: Array<Notification>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Notification>;
};

export enum NotificationType {
  /** The notification indicates that the account is under review. */
  StatusReview = 'STATUS_REVIEW',
  /** The notification indicates that the account is banned. */
  StatusBanned = 'STATUS_BANNED',
  /** The notification indicates that the account has been canceled by the employee. */
  StatusSelfCanceled = 'STATUS_SELF_CANCELED',
  /** The notification indicates that the account has been canceled by the employer. */
  StatusEmployerCanceled = 'STATUS_EMPLOYER_CANCELED',
  /** The notification indicates that the account's cancellation has completed. */
  StatusCancelComplete = 'STATUS_CANCEL_COMPLETE',
  /** The notification indicates that the account has been canceled and the employee is owed a final payment. */
  StatusFinalPaymentOwedCanceling = 'STATUS_FINAL_PAYMENT_OWED_CANCELING',
  /** The notification indicates that the account has been canceled and the employee is owed a final payment. */
  StatusNegativeCurrentBalanceCanceling = 'STATUS_NEGATIVE_CURRENT_BALANCE_CANCELING',
  /** The notification indicates that the account is paused due to inactivity but reactivatable. */
  StatusEnterpriseReactivatablePaused = 'STATUS_ENTERPRISE_REACTIVATABLE_PAUSED',
  /** The notification indicates that the account is paused due to inactivity. */
  StatusPaused = 'STATUS_PAUSED',
  /** The notification indicates that the employee requested to subtract from their next paycheck in response to a negative balance. */
  NegativeBalancePayoffWorkoff = 'NEGATIVE_BALANCE_PAYOFF_WORKOFF',
  /** The notification indicates that the employee has a workoff plan that automatically deducts from their next paycheck in response to a negative balance. */
  NegativeBalancePayoffAutoWorkoff = 'NEGATIVE_BALANCE_PAYOFF_AUTO_WORKOFF',
  /** The notification indicates that the employee requested a workoff plan to debit their bank account in response to a negative balance. */
  NegativeBalancePayoffAchDebit = 'NEGATIVE_BALANCE_PAYOFF_ACH_DEBIT',
  /** The notification indicates that the employee requested a payment plan over a period of time in response to a negative balance. */
  NegativeBalancePayoffPaymentPlan = 'NEGATIVE_BALANCE_PAYOFF_PAYMENT_PLAN',
  /** The notification indicates that the employee is on a payment plan and their last paycheck was insufficient to make their payment. */
  NegativeBalancePayoffLatestWorkoffLessThanPlannedPaymentPlan = 'NEGATIVE_BALANCE_PAYOFF_LATEST_WORKOFF_LESS_THAN_PLANNED_PAYMENT_PLAN',
  /** The notification indicates that instant payments are unavailable due to scheduled maintenance. */
  InstantMaintenance = 'INSTANT_MAINTENANCE',
  /** The notification indicates that instant payments are unavailable due to unplanned downtime. */
  UnplannedInstantDowntime = 'UNPLANNED_INSTANT_DOWNTIME',
  /** The notification indicates that the employee has not received a payment to their primary bank account in the last 30 days and need to confirm the account is still valid. */
  StaleBank = 'STALE_BANK',
  /** The notification indicates that the employee has an inactivate provider account that can be activated. */
  ActivatableProviderAccount = 'ACTIVATABLE_PROVIDER_ACCOUNT',
  /** The notification indicates that the employee should view an announcement. */
  Announcement = 'ANNOUNCEMENT',
  /** The notification indicates that the available balance is below the minimum advance amount. */
  CustomBalanceRefreshMessage = 'CUSTOM_BALANCE_REFRESH_MESSAGE',
  /** The notification indicates the the employee is eligible for a sweepstakes. */
  Sweepstakes = 'SWEEPSTAKES',
  /** The notification indicates that the employee currently has a referral bonus available to be advanced. */
  ReferralBonus = 'REFERRAL_BONUS',
  /** The notification indicates that the employee currently has a referrer bonus available to be advanced. */
  ReferrerBonus = 'REFERRER_BONUS',
  /** The notification indicates that the employee currently has a referee bonus available to be advanced. */
  RefereeBonus = 'REFEREE_BONUS',
  /** The notification indicates that the employee is eligible for a free transfer promotion. */
  FreeTransferPromotion = 'FREE_TRANSFER_PROMOTION'
}

export type OffCyclePaymentOptions = {
  __typename?: 'OffCyclePaymentOptions';
  currentRepaymentExpectedDate: Scalars['ISO8601DateTime'];
  /** Set to true if the provider is billed by debit for cycle repayments. */
  cycleBillingDebit: Scalars['Boolean'];
  /** Fee (cents) for disbursements sent to user_s DPA */
  cycleDpaFeeCents: Scalars['Int'];
  /** True if this provider requires secondary approval for cycle payments */
  cycleRequiresApproval: Scalars['Boolean'];
  /** Fee (cents) for disbursements sent to user_s bank */
  cycleUserBankFeeCents: Scalars['Int'];
  /** True if the provider has the ability to use cycle batch product */
  enableBatchOffCycleDisbursements: Scalars['Boolean'];
  /** True if the provider has the ability to use cycle product */
  enableOffCycleDisbursements: Scalars['Boolean'];
  /** The maximum amount for an off cycle payment, depending on approval. */
  maxAmountCents: Scalars['Int'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export enum PartnerReport {
  /** A list of outstanding balances for each user. */
  Balance = 'BALANCE',
  /** A list of users. */
  User = 'USER'
}

export type PartnerRole = {
  __typename?: 'PartnerRole';
  /** Short description for this role. */
  description: Scalars['String'];
  /** The text identifier for this role. */
  oid: EmployerPermissions;
  /** The scope for this role. Examples: full, location. */
  scope: Scalars['String'];
};

/** The connection type for PartnerRole. */
export type PartnerRoleConnection = {
  __typename?: 'PartnerRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerRoleEdge>>>;
  /** A page of PartnerRole objects. */
  items: Array<PartnerRole>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PartnerRole>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PartnerRoleEdge = {
  __typename?: 'PartnerRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerRole>;
};

export type PartnersMutation = {
  __typename?: 'PartnersMutation';
  createDirectDepositUpdateFile: CreateDirectDepositUpdateFilePayload;
  createDisbursement: CreateDisbursementPayload;
  /** Allows for the creation of new managers at either the provider or company scope. */
  createManager: CreateManagerPayload;
  createPartnerReport: CreatePartnerReportPayload;
  createReward: CreateRewardPayload;
  enableSmsOnboarding: EnableSmsOnboardingPayload;
  exportCashBalanceReport: ExportCashBalanceReportPayload;
  exportDduConsentReport: ExportDduConsentReportPayload;
  exportPayrollExtenderReport: ExportPayrollExtenderReportPayload;
  exportPaystubReport: ExportPaystubReportPayload;
  exportPresettlementExclusionReport: ExportPresettlementExclusionReportPayload;
  exportRewardsReport: ExportRewardsReportPayload;
  generateBatchDisbursementUploadUrl: GenerateBatchDisbursementUploadUrlPayload;
  generateBatchOnboardUrl: GenerateBatchOnboardUrlPayload;
  generateDduReportUrl: GenerateDduReportUrlPayload;
  generatePartnerReportUrl: GeneratePartnerReportUrlPayload;
  generatePayrollAnomalyReportUrl: GeneratePayrollAnomalyReportUrlPayload;
  generateRewardsReportUrl: GenerateRewardsReportUrlPayload;
  switchProvider: SwitchProviderPayload;
  terminateUser: TerminateUserPayload;
  updateBatchDisbursement: UpdateBatchDisbursementPayload;
  updateDisbursement: UpdateDisbursementPayload;
  updateEmployerNotificationSettings: UpdateEmployerNotificationSettingsPayload;
  updateEmployerRewardBudget: UpdateEmployerRewardBudgetPayload;
  updateManagerStatus: UpdateManagerStatusPayload;
  updateReward: UpdateRewardPayload;
  updateUserFinalPay: UpdateUserFinalPayPayload;
  updateUserStatus: UpdateUserStatusPayload;
  uploadBatchDisbursement: UploadBatchDisbursementPayload;
  uploadBatchOnboard: UploadBatchOnboardPayload;
  uploadGrossEarnings: UploadGrossEarningsPayload;
  uploadPayrollJournal: UploadPayrollJournalPayload;
};


export type PartnersMutationCreateDisbursementArgs = {
  input: CreateDisbursementInput;
};


export type PartnersMutationCreateManagerArgs = {
  input: CreateManagerInput;
};


export type PartnersMutationCreatePartnerReportArgs = {
  reportType: PartnerReport;
};


export type PartnersMutationCreateRewardArgs = {
  input: CreateRewardInput;
};


export type PartnersMutationEnableSmsOnboardingArgs = {
  pendingUserSmsAllowed: Scalars['Boolean'];
};


export type PartnersMutationExportCashBalanceReportArgs = {
  payPeriodEndsAtDate: Scalars['ISO8601Date'];
};


export type PartnersMutationExportPayrollExtenderReportArgs = {
  requesterId?: Maybe<Scalars['ID']>;
};


export type PartnersMutationExportPaystubReportArgs = {
  payPeriodEndsAtDate?: Maybe<Scalars['ISO8601Date']>;
};


export type PartnersMutationExportPresettlementExclusionReportArgs = {
  paymentExpectedOn: Scalars['ISO8601Date'];
};


export type PartnersMutationExportRewardsReportArgs = {
  requesterId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  approvedBetween?: Maybe<DateRangeInput>;
  claimedBetween?: Maybe<DateRangeInput>;
};


export type PartnersMutationGenerateBatchDisbursementUploadUrlArgs = {
  filename: Scalars['String'];
};


export type PartnersMutationGenerateBatchOnboardUrlArgs = {
  batchOnboardId: Scalars['ID'];
};


export type PartnersMutationGeneratePartnerReportUrlArgs = {
  reportType: PartnerReport;
};


export type PartnersMutationGeneratePayrollAnomalyReportUrlArgs = {
  payrollJournalId: Scalars['ID'];
};


export type PartnersMutationGenerateRewardsReportUrlArgs = {
  requesterId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  approvedBetween?: Maybe<DateRangeInput>;
  claimedBetween?: Maybe<DateRangeInput>;
};


export type PartnersMutationSwitchProviderArgs = {
  providerId: Scalars['ID'];
};


export type PartnersMutationTerminateUserArgs = {
  providerAccountId?: Maybe<Scalars['ID']>;
  employeeProfileId?: Maybe<Scalars['ID']>;
};


export type PartnersMutationUpdateBatchDisbursementArgs = {
  batchDisbursementId: Scalars['ID'];
  approved: Scalars['Boolean'];
};


export type PartnersMutationUpdateDisbursementArgs = {
  approved: Scalars['Boolean'];
  disbursementId: Scalars['ID'];
};


export type PartnersMutationUpdateEmployerNotificationSettingsArgs = {
  input: UpdateEmployerNotificationSettingsInput;
};


export type PartnersMutationUpdateEmployerRewardBudgetArgs = {
  input: UpdateEmployerRewardBudgetInput;
};


export type PartnersMutationUpdateManagerStatusArgs = {
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
};


export type PartnersMutationUpdateRewardArgs = {
  rewardId: Scalars['ID'];
  approverId: Scalars['ID'];
  approved: Scalars['Boolean'];
};


export type PartnersMutationUpdateUserFinalPayArgs = {
  input: UpdateUserFinalPayInput;
};


export type PartnersMutationUpdateUserStatusArgs = {
  enabled: Scalars['Boolean'];
  providerAccountId: Scalars['ID'];
};


export type PartnersMutationUploadBatchDisbursementArgs = {
  input: FileUploadInput;
  reason: DisbursementReasonCategory;
};


export type PartnersMutationUploadBatchOnboardArgs = {
  input: FileUploadInput;
};


export type PartnersMutationUploadGrossEarningsArgs = {
  input: FileUploadInput;
};


export type PartnersMutationUploadPayrollJournalArgs = {
  input: FileUploadInput;
};

/** The query root of the partners schema. */
export type PartnersQuery = {
  __typename?: 'PartnersQuery';
  /** API response logs */
  apiResponseLogs: ApiResponseLogConnection;
  /** Batches of one-off payments made by provider */
  batchDisbursements?: Maybe<BatchDisbursementFileConnection>;
  /** User roster files associated with the given provider */
  batchOnboardFiles: BatchOnboardFileConnection;
  /** Lookup companies for this provider. */
  companies: ProviderCompanyConnection;
  /** Return one of several compliance reports (i.e. the Direct Deposit Update Consent Report). */
  complianceReports: ComplianceReports;
  /** Show all downloaded direct deposit update files. */
  directDepositUpdateFiles: DirectDepositUpdateFileConnection;
  /** One off payments made by provider */
  disbursements?: Maybe<DisbursementConnection>;
  /** Return individual employee profile associated with the logged in employer. */
  employeeProfile: EmployeeProfile;
  /** Return employee profiles associated with the logged in employer. */
  employeeProfiles: EmployeeProfileConnection;
  /** Account info for the logged in user. */
  employer: Employer;
  /** Show all uploaded gross earnings */
  grossEarningsTransmissionFiles?: Maybe<GrossEarningsTransmissionFileConnection>;
  /** Show other employers for a given provider. */
  managers: ManagerConnection;
  /** Type contains a URL for the embeddable iFrame */
  metabaseDashboardToken: Scalars['String'];
  /** Return all configured roles. */
  partnerRoles: PartnerRoleConnection;
  /** Return details for the net earnings upload file. */
  payrollJournalFile?: Maybe<PayrollJournalFile>;
  /** Net earnings upload files */
  payrollJournalFiles?: Maybe<PayrollJournalFileConnection>;
  /** Pay periods that were excluded from presettlement. */
  presettlementExclusions: PresettlementExclusionConnection;
};


/** The query root of the partners schema. */
export type PartnersQueryApiResponseLogsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  logCategory: ApiResponseLogCategory;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryBatchDisbursementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  requesterId?: Maybe<Scalars['ID']>;
  createdAtBetween?: Maybe<DateRangeInput>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryBatchOnboardFilesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryCompaniesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryDirectDepositUpdateFilesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryDisbursementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  requesterId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  singleDisbursementsOnly?: Maybe<Scalars['Boolean']>;
  createdAtBetween?: Maybe<DateRangeInput>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryEmployeeProfileArgs = {
  id: Scalars['ID'];
};


/** The query root of the partners schema. */
export type PartnersQueryEmployeeProfilesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  locationIds?: Maybe<Array<Scalars['ID']>>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  userStatus?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<Scalars['String']>;
  benefitType?: Maybe<Scalars['String']>;
};


/** The query root of the partners schema. */
export type PartnersQueryGrossEarningsTransmissionFilesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryManagersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryMetabaseDashboardTokenArgs = {
  dashboard?: Maybe<MetabaseDashboardToken>;
};


/** The query root of the partners schema. */
export type PartnersQueryPartnerRolesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryPayrollJournalFileArgs = {
  id: Scalars['ID'];
};


/** The query root of the partners schema. */
export type PartnersQueryPayrollJournalFilesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


/** The query root of the partners schema. */
export type PartnersQueryPresettlementExclusionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  paymentExpectedOn?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type PayPeriod = {
  __typename?: 'PayPeriod';
  /** Accrued savings amount in this pay period. */
  accruedAutoSavingsAmountCents: Scalars['Int'];
  /** Total non-presettlement processable advances. */
  advancedAmountCents: Scalars['Int'];
  /** Advances for the employee associated with this pay period. */
  advances: EmployeeAdvanceConnection;
  /** Available balance in this pay period. */
  availableBalanceCents: Scalars['Int'];
  /** Bonuses for the employee associated with this pay period. */
  bonuses: BonusConnection;
  /** The company (pay group) associated with this pay period. */
  company: ProviderCompany;
  /** True if the company pay period is advanceable. */
  companyPayPeriodAdvanceable: Scalars['Boolean'];
  /** Number of days until next payday. */
  daysUntilNextPayday: Scalars['Int'];
  /** True if earnings are accessible for this pay period. */
  earningsAccessible: Scalars['Boolean'];
  /** Reason earnings are not accessible for this pay period. */
  earningsLockedReason?: Maybe<Scalars['String']>;
  /** The employee associated for this pay period. */
  employee: Employee;
  /** Payments to the employee. */
  employeePayments: EmployeePaymentConnection;
  /** Time and date of when the pay period ended. */
  endsAt: Scalars['ISO8601DateTime'];
  /** The date when the pay period ended. */
  endsAtDate: Scalars['ISO8601Date'];
  /** Primary key for the pay period. Null if the pay period does not exist yet. */
  id?: Maybe<Scalars['ID']>;
  /** The name of the pay group associated with this pay period. */
  name: Scalars['String'];
  /** The datetime provider payment is expected. */
  nextPaymentExpectedAt: Scalars['ISO8601DateTime'];
  /** The date provider payment is expected. */
  nextPaymentExpectedAtDate: Scalars['ISO8601Date'];
  /** Payday reserves for the employee associated with this pay period. */
  paydayReserves: PaydayReserveConnection;
  /** The provider account external ID for this pay period. */
  providerAccountExternalId: Scalars['String'];
  /** The provider's display name for the user associated with this pay period. */
  providerDisplayName: Scalars['String'];
  /** Payments from the provider. */
  providerPayments: ProviderPaymentConnection;
  /** Savings deducted in this pay period. */
  savingsDeduction: Scalars['Int'];
  /** Settlements and pre-settlements for the employee associated with this pay period. */
  settlements: EmployeeSettlementConnection;
  /** All shifts worked in this pay period. */
  shifts?: Maybe<ShiftConnection>;
  /** Time and date of when the pay period started. */
  startsAt: Scalars['ISO8601DateTime'];
  /** The date when the pay period started. */
  startsAtDate: Scalars['ISO8601Date'];
  /** The status of this pay period. */
  status: Scalars['String'];
  /** Summary of transfers and fees in this pay period. */
  summary: PayPeriodSummary;
  /**
   * The total dollar amount of gross earnings for this pay period.
   * @deprecated This field displays gross earnings and is deprecated in favor of `grossEarningsCents`
   */
  totalAmountCents: Scalars['Int'];
};


export type PayPeriodAdvancesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type PayPeriodBonusesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type PayPeriodEmployeePaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type PayPeriodPaydayReservesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type PayPeriodProviderPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type PayPeriodSettlementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type PayPeriodShiftsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for PayPeriod. */
export type PayPeriodConnection = {
  __typename?: 'PayPeriodConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayPeriodEdge>>>;
  /** A page of PayPeriod objects. */
  items: Array<PayPeriod>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PayPeriod>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PayPeriodEdge = {
  __typename?: 'PayPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PayPeriod>;
};

export type PayPeriodSummary = {
  __typename?: 'PayPeriodSummary';
  /** The total dollar amount of the estimated net earnings for this pay period. */
  estimatedNetEarningsAmountCents: Scalars['Int'];
  /** The total dollar amount of gross earnings for this pay period. */
  grossEarningsAmountCents: Scalars['Int'];
  /** For a settled pay period, the negative balance in cents. */
  negativeBalanceAmountCents?: Maybe<Scalars['Int']>;
  /** For a settled pay period, the amount paid towards a previous negative balance. */
  negativeBalancePaidSettlementAmountCents?: Maybe<Scalars['Int']>;
  /**
   * Negative balance for a current pay period.
   * @deprecated Deprecated in favor of negativeBalanceAmountCents
   */
  negativeUnprocessedSettlementAmountCents?: Maybe<Scalars['Int']>;
  /** The total dollar amount of final net earnings for this pay period. */
  netEarningsAmountCents?: Maybe<Scalars['Int']>;
  /** The amount in cents of final net earnings from the payroll journal. */
  payrollJournalPayAmountCents?: Maybe<Scalars['Int']>;
  /** For a settled pay period, the amount transferred to the user owned employee bank account. */
  remainderAmountCents?: Maybe<Scalars['Int']>;
  /** Total fees paid in this pay period. */
  totalFeeAmountCents: Scalars['Int'];
  /** The total dollar amount of the payday reserves for this pay period. */
  totalPaydayReservesAmountCents: Scalars['Int'];
  /** Total amount advanced in this pay period (not including fees). */
  totalTransferredEarlyAmountCents: Scalars['Int'];
  /** For a settled pay period, total dollar amount transferred to user bank accounts and cards. */
  totalTransferredToEmployeeCents?: Maybe<Scalars['Int']>;
};


export type PayPeriodSummaryTotalTransferredEarlyAmountCentsArgs = {
  includeFees?: Maybe<Scalars['Boolean']>;
};

export type PaydayReserve = {
  __typename?: 'PaydayReserve';
  /** The date the payday reserve was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID for the payday reserve. */
  id: Scalars['ID'];
  /** The pay period the payday reserve was created on. */
  payPeriod: PayPeriod;
  /** The product type that created the payday reserve. */
  product: PaydayReserveProduct;
  /** The provider associated with this payday reserve. */
  provider: Provider;
  /** The status for the payday reserve. */
  status: Scalars['String'];
  /** Total amount of payday reserve in cents. */
  totalAmountCents: Scalars['Int'];
  /** Currency for total amount of payday reserve. */
  totalAmountCurrency: Scalars['String'];
};

/** The connection type for PaydayReserve. */
export type PaydayReserveConnection = {
  __typename?: 'PaydayReserveConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaydayReserveEdge>>>;
  /** A page of PaydayReserve objects. */
  items: Array<PaydayReserve>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaydayReserve>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaydayReserveEdge = {
  __typename?: 'PaydayReserveEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaydayReserve>;
};

export enum PaydayReserveProduct {
  /** The payday reserve was created for the Direct Savings product. */
  Direct = 'DIRECT',
  /** The payday reserve was created for the Roundup Savings product. */
  Roundup = 'ROUNDUP',
  /** The payday reserve was created for the Automatic Savings product. */
  Automatic = 'AUTOMATIC',
  /** The product that the payday reserve was created for is not known. */
  Unknown = 'UNKNOWN'
}

export type PayoffEntry = {
  __typename?: 'PayoffEntry';
  /** The date the bonus was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID for the bonus. */
  id: Scalars['ID'];
  /** One of workoff, auto_workoff, payment_plan, ach_debit. */
  payoffMethod: Scalars['String'];
  /** The time payoff selection was made. */
  payoffSelectionMadeAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the provider account this payoff entry belongs to. */
  providerAccountId: Scalars['Int'];
  /** Payoff status - one of pending, canceled, processed. */
  status: Scalars['String'];
  /** Total amount of bonus in cents. */
  totalAmountCents: Scalars['Int'];
  /** Currency for total amount of payday reserve. */
  totalAmountCurrency: Scalars['String'];
};

export type PayrollAnomalyReport = {
  __typename?: 'PayrollAnomalyReport';
  /** Return anomalies associated with this net earnings report. */
  outliers: PayrollAnomalyReportOutlierConnection;
  /** Return stats for the payroll journal file */
  stats: PayrollAnomalyReportStats;
};


export type PayrollAnomalyReportOutliersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type PayrollAnomalyReportOutlier = {
  __typename?: 'PayrollAnomalyReportOutlier';
  /** Return the deviation from the mean for the outlier */
  deviationFromMean: Scalars['Float'];
  /** Return the deviation from the mean for the outlier, as a percentage */
  deviationFromMeanPercentage: Scalars['Float'];
  /** Return the external ID of the outlier user */
  externalId: Scalars['String'];
  /** Return the first name of the outlier user */
  firstName: Scalars['String'];
  /** Return the last name of the outlier user */
  lastName: Scalars['String'];
  /** Return the net pay of the outlier */
  netPay: Scalars['Float'];
  /** Return the mean net pay for the outlier */
  netPayMean: Scalars['Float'];
  /** Return the standard deviation of the net pay for the outlier */
  netPayStandardDeviation: Scalars['Float'];
  /** Return the pay date for the outlier */
  payDate?: Maybe<Scalars['ISO8601Date']>;
  /** Return the pay period end date for the outlier */
  payPeriodEnd?: Maybe<Scalars['ISO8601Date']>;
};

/** The connection type for PayrollAnomalyReportOutlier. */
export type PayrollAnomalyReportOutlierConnection = {
  __typename?: 'PayrollAnomalyReportOutlierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayrollAnomalyReportOutlierEdge>>>;
  /** A page of PayrollAnomalyReportOutlier objects. */
  items: Array<PayrollAnomalyReportOutlier>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PayrollAnomalyReportOutlier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PayrollAnomalyReportOutlierEdge = {
  __typename?: 'PayrollAnomalyReportOutlierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PayrollAnomalyReportOutlier>;
};

export type PayrollAnomalyReportStats = {
  __typename?: 'PayrollAnomalyReportStats';
  /** Return the total number of duplicate employees in the payroll journal */
  duplicateEmployeeCount: Scalars['Int'];
  /** Return the total number of duplicate lines in the payroll journal */
  duplicateLineCount: Scalars['Int'];
  /** Return the total number of employees in the payroll journal */
  employeeCount: Scalars['Int'];
  /** Return the total number of lines in the payroll journal */
  lineCount: Scalars['Int'];
  /** Return the total number of employees missing from the payroll journal */
  missingEmployeeCount: Scalars['Int'];
  /** Return the total number of net pay records missing from the payroll journal */
  missingNetPayCount: Scalars['Float'];
  /** Return the maximum net pay in the payroll journal */
  netPayMaximum: Scalars['Float'];
  /** Return the mean net pay in the payroll journal */
  netPayMean: Scalars['Float'];
  /** Return the minimum net pay in the payroll journal */
  netPayMinimum: Scalars['Float'];
  /** Return the sum total net pay in the payroll journal */
  netPaySum: Scalars['Float'];
};

/** Payroll journals (a.k.a. net earnings files) for a given file */
export type PayrollJournalFile = File & {
  __typename?: 'PayrollJournalFile';
  /** Show the details of anomalies for a payroll journal */
  anomalyReport?: Maybe<PayrollAnomalyReport>;
  /** Original net earnings file, hosted on S3 */
  attachment?: Maybe<StrictMimeAttachment>;
  /** The date the file was processed and created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who uploaded the attachment. */
  creator: User;
  /** The ID of the file */
  id: Scalars['ID'];
  /** The original name of the uploaded file. */
  originalFilename: Scalars['String'];
  /** The status of the upload. */
  status: Scalars['String'];
  /** Whether an anomaly report is available for this net earnings file for this session */
  supportsAnomalyReport: Scalars['Boolean'];
};

/** The connection type for PayrollJournalFile. */
export type PayrollJournalFileConnection = {
  __typename?: 'PayrollJournalFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayrollJournalFileEdge>>>;
  /** A page of PayrollJournalFile objects. */
  items: Array<PayrollJournalFile>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PayrollJournalFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PayrollJournalFileEdge = {
  __typename?: 'PayrollJournalFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PayrollJournalFile>;
};

export enum PhotoIdStatus {
  /** The employee previously uploaded a photo ID, but it was deleted either by Ops rejecting it or virus scan failing. Re-upload is required. */
  Rejected = 'REJECTED',
  /** The employee either uploaded a photo ID and is awaiting approval or the async job to create it has not ran yet. No action required from the employee, but PayTM actions should be disabled. */
  Pending = 'PENDING',
  /** The employee uploaded a photo ID which passed virus scan and was accepted by Ops. */
  Accepted = 'ACCEPTED'
}

export type PresettlementExclusion = {
  __typename?: 'PresettlementExclusion';
  /** A detailed reason why this provider account was excluded. */
  exclusionNote?: Maybe<Scalars['String']>;
  /** The reason this provider account was excluded. */
  exclusionType?: Maybe<Scalars['String']>;
  /** Primary key for the presettlement exclusion. */
  id: Scalars['ID'];
  /** The pay period associated with this company pay period and provider account. */
  payPeriod?: Maybe<PayPeriod>;
  /** Return provider account associated with this presettlement exclusion. */
  providerAccount: ProviderAccount;
};

/** The connection type for PresettlementExclusion. */
export type PresettlementExclusionConnection = {
  __typename?: 'PresettlementExclusionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresettlementExclusionEdge>>>;
  /** A page of PresettlementExclusion objects. */
  items: Array<PresettlementExclusion>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PresettlementExclusion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PresettlementExclusionEdge = {
  __typename?: 'PresettlementExclusionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PresettlementExclusion>;
};

export type Provider = {
  __typename?: 'Provider';
  /** List of allowed email domains */
  allowedDomainNames?: Maybe<Array<Scalars['String']>>;
  /** Custom configurations for provider. */
  customizationProfile?: Maybe<CustomizationProfile>;
  /** Return a list of employee profiles enrolled in payroll extender. */
  employeesEnrolledInPayrollExtender?: Maybe<EmployeeProfileConnection>;
  /** Return a list of employers rewards budgets. */
  employerRewardBudgets: EmployerRewardBudgetConnection;
  /** Return employers for this provider. */
  employers: EmployerConnection;
  /** True if the punch card is enabled. */
  enablePunchCard: Scalars['Boolean'];
  /** True if text message notifications are enabled. */
  enableTextMessages: Scalars['Boolean'];
  /** Enabled features for this provider. */
  enabledFeatures: FeatureConnection;
  /** True if fiserv debit push is enabled. */
  fiservDebitPushEnabled: Scalars['Boolean'];
  /** Date this provider will turn on Friday enrollment for its users */
  fridayGoliveOn?: Maybe<Scalars['ISO8601Date']>;
  /** Number of users currently on Friday waitlist globally */
  fridayWaitlistCount: Scalars['Int'];
  /** The path to an icon/logo for this provider. */
  icon?: Maybe<Scalars['String']>;
  /** Primary key for the provider. */
  id: Scalars['ID'];
  /** True if the provider has international data restrictions */
  internationalRestricted: Scalars['Boolean'];
  /** List of metrics for current provider */
  metrics: ProviderMetrics;
  /** The name of the provider. */
  name: Scalars['String'];
  /** Options and fees for off cycle payments/disbursements. */
  offCyclePaymentOptions: OffCyclePaymentOptions;
  /** True if only current pay period earnings are allowed. */
  onlyAllowCurrentPayPeriodEarnings: Scalars['Boolean'];
  /** Unique pay period end dates for compliance reports. */
  payPeriodEndDates: Array<Scalars['ISO8601Date']>;
  /** Unique pay period payment expected on dates for pre-settlement exclusion reports. */
  payPeriodPaymentExpectedOnDates: Array<Scalars['ISO8601Date']>;
  /** True if provider has payroll extender enabled. */
  payrollExtenderEnabled: Scalars['Boolean'];
  /** True if pending user sms allowed enabled */
  pendingUserSmsAllowed: Scalars['Boolean'];
  /** Return the permissions for the logged in user on this provider. */
  permissions: ProviderPermissions;
  /** True if this provider settles to multiple banks. */
  presettleManyDirectDepositBanks?: Maybe<Scalars['Boolean']>;
  /** The amount the referrer receives. */
  referrerBonusAmountCents: Scalars['Int'];
  /** A message for employees with additional information about refreshing the balance. */
  refreshBalanceMessage: Scalars['String'];
  /** Options and fees for rewards on this provider. */
  rewardOptions: RewardOptions;
  /** Return a list of rewards. */
  rewards: RewardConnection;
  /** Employee support phone number for this provider. */
  supportPhoneNumber: Scalars['String'];
  /** White labeled partners for this provider. */
  whiteLabelPartnerIdentifier: Scalars['String'];
  /**
   * White labeled referral code for this provider.
   * @deprecated This field is being replaced by wiselyReferralCode
   */
  whiteLabelReferralCode?: Maybe<Scalars['String']>;
  /** White labeled referral code for this provider. */
  wiselyReferralCode?: Maybe<Scalars['String']>;
};


export type ProviderEmployeesEnrolledInPayrollExtenderArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type ProviderEmployerRewardBudgetsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type ProviderEmployersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']>>;
};


export type ProviderEnabledFeaturesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type ProviderRewardsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  requesterId?: Maybe<Scalars['ID']>;
  createdAtBetween?: Maybe<DateRangeInput>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** Associates a user to a company and provider. */
export type ProviderAccount = {
  __typename?: 'ProviderAccount';
  /** Company/paygroup associated with this provider account. */
  company: ProviderCompany;
  /** The employee associated with this provider account. */
  employee: Employee;
  /** The external ID for this provider account. */
  externalId: Scalars['String'];
  /** The date for the first associated pull advance. */
  firstAdvanceCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Primary key for provider account */
  id: Scalars['ID'];
  /** Return the given pay period by ID. */
  payPeriod: PayPeriod;
  /** Return the pay periods for this account. */
  payPeriods?: Maybe<PayPeriodConnection>;
  /** The status of this provider account */
  status: Scalars['String'];
};


/** Associates a user to a company and provider. */
export type ProviderAccountPayPeriodArgs = {
  id: Scalars['ID'];
};


/** Associates a user to a company and provider. */
export type ProviderAccountPayPeriodsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** The connection type for ProviderAccount. */
export type ProviderAccountConnection = {
  __typename?: 'ProviderAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderAccountEdge>>>;
  /** A page of ProviderAccount objects. */
  items: Array<ProviderAccount>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProviderAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProviderAccountEdge = {
  __typename?: 'ProviderAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderAccount>;
};

/** Associates a provider account to a pay group for a provider. */
export type ProviderCompany = {
  __typename?: 'ProviderCompany';
  /** Primary key for the company. */
  id: Scalars['ID'];
  /** A pay cycle for a provider. */
  payGroup: Scalars['String'];
  /** Primary key for the provider. */
  providerId: Scalars['ID'];
};

/** The connection type for ProviderCompany. */
export type ProviderCompanyConnection = {
  __typename?: 'ProviderCompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderCompanyEdge>>>;
  /** A page of ProviderCompany objects. */
  items: Array<ProviderCompany>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProviderCompany>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProviderCompanyEdge = {
  __typename?: 'ProviderCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderCompany>;
};

/** The connection type for Provider. */
export type ProviderConnection = {
  __typename?: 'ProviderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderEdge>>>;
  /** A page of Provider objects. */
  items: Array<Provider>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Provider>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProviderEdge = {
  __typename?: 'ProviderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Provider>;
};

/** A location for the employee profile or provider account. */
export type ProviderLocation = {
  __typename?: 'ProviderLocation';
  /** Primary key for the location. */
  id: Scalars['ID'];
  /** The name given to the location. */
  name?: Maybe<Scalars['String']>;
  /** Primary key for the associated provider. */
  providerId?: Maybe<Scalars['ID']>;
};

/** The connection type for ProviderLocation. */
export type ProviderLocationConnection = {
  __typename?: 'ProviderLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderLocationEdge>>>;
  /** A page of ProviderLocation objects. */
  items: Array<ProviderLocation>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProviderLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProviderLocationEdge = {
  __typename?: 'ProviderLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderLocation>;
};

/** List of metrics calculated for current provider */
export type ProviderMetrics = {
  __typename?: 'ProviderMetrics';
  /** Count of users in a currently active state. */
  active: Scalars['Int'];
  /** Count of users with two or more transfers. */
  champions: Scalars['Int'];
  /** Count of users in a currently active or pending state. */
  eligible: Scalars['Int'];
  /** Total cents transferred by all users under current provider. */
  transferredLast7DaysCents: Scalars['Int'];
  /** Count of users with recent invoices. */
  withRecentInvoices: Scalars['Int'];
};

export type ProviderPayment = {
  __typename?: 'ProviderPayment';
  /** DailyPay bank account number where this payment was sent. */
  accountNumber?: Maybe<Scalars['String']>;
  /** Primary key for the payment. */
  id: Scalars['ID'];
  /** The date the payment was processed. */
  processedOn: Scalars['ISO8601DateTime'];
  /** Dollar amount in cents for this payment. */
  totalAmountCents: Scalars['Int'];
};

/** The connection type for ProviderPayment. */
export type ProviderPaymentConnection = {
  __typename?: 'ProviderPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderPaymentEdge>>>;
  /** A page of ProviderPayment objects. */
  items: Array<ProviderPayment>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProviderPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProviderPaymentEdge = {
  __typename?: 'ProviderPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderPayment>;
};

export type ProviderPermissions = {
  __typename?: 'ProviderPermissions';
  /** True if employer can create admins for this provider. */
  canCreateAdmins: Scalars['Boolean'];
  /** True if employer can upload batch onboard files. */
  canCreateBatchOnboard: Scalars['Boolean'];
  /** True if employer should use can_create_ddu mutation instead of generate_report_url */
  canCreateDirectDepositUpdateFiles: Scalars['Boolean'];
  /** True if employer can create disbursement payments. */
  canCreateDisbursements: Scalars['Boolean'];
  /** True if employer can view and upload gross earnings. */
  canCreateGrossEarnings: Scalars['Boolean'];
  /** True if employer can view and upload net earnings. */
  canCreateNetEarnings: Scalars['Boolean'];
  /** True if employer can set reward allocations to all operating managers. */
  canCreateRewardBudgets: Scalars['Boolean'];
  /** True if employer can grant rewards. */
  canCreateRewards: Scalars['Boolean'];
  /** True if employer can download DDUs. */
  canDownloadDirectDepositUpdates: Scalars['Boolean'];
  /** True if employer can generate payroll extender reports. */
  canGeneratePayrollExtenderReports: Scalars['Boolean'];
  /** True if employer can view admins for this provider. */
  canListAdmins: Scalars['Boolean'];
  /** True if employer can view batch disbursements. */
  canListBatchDisbursements: Scalars['Boolean'];
  /** True if employer can view disbursement payments. */
  canListDisbursements: Scalars['Boolean'];
  /** True if employer can list gross earnings files. */
  canListGrossEarnings: Scalars['Boolean'];
  /** True if employer can list net earnings files. */
  canListNetEarnings: Scalars['Boolean'];
  /** True if employer can view rewards. */
  canListRewards: Scalars['Boolean'];
  /** True if employer can view api logs. */
  canShowApiLogs: Scalars['Boolean'];
  /** True if employer can view bank accounts. */
  canShowBankAccounts: Scalars['Boolean'];
  /** True if employer can terminate employees. */
  canTerminateEmployee: Scalars['Boolean'];
  /** True if employer can update admins for this provider. */
  canUpdateAdminStatus: Scalars['Boolean'];
  /** True if employer can enable/disable employees. */
  canUpdateEmployeeStatus: Scalars['Boolean'];
  /** True if employer can update email notification settings. */
  canUpdateNotificationSettings: Scalars['Boolean'];
  /** True if employer can download batch onboard files. */
  canViewBatchOnboard: Scalars['Boolean'];
  /** True if employer can view compliance reports. */
  canViewComplianceReports: Scalars['Boolean'];
  /** True if employer can view Cycle reports. */
  canViewCycleReports: Scalars['Boolean'];
  /** True if employer can view Data Exchange tab (user roster, gross, net earnings, DDU) for this provider. */
  canViewDataExchange: Scalars['Boolean'];
  /** True if employer can download DDU files. */
  canViewDirectDepositUpdates: Scalars['Boolean'];
  /** True if employer can download gross earnings files. */
  canViewGrossEarnings: Scalars['Boolean'];
  /** True if employer can view Metabase enrollment and usage reports. */
  canViewMetabaseReports: Scalars['Boolean'];
  /** True if employer can download net earnings files. */
  canViewNetEarnings: Scalars['Boolean'];
  /** True if employer can view payroll extender reports. */
  canViewPayrollExtenderReports: Scalars['Boolean'];
  /** True if employer can view DDU pending update count. */
  canViewPendingUpdateCount: Scalars['Boolean'];
  /** True if employer can view presettlement exclusion reports. */
  canViewPresettlementExclusionReports: Scalars['Boolean'];
  /** True if employer can view reporting tab (enrollment, usage, compliance etc) for this provider. */
  canViewReports: Scalars['Boolean'];
};

export type PullAdvance = {
  __typename?: 'PullAdvance';
  /** The list of negative balance payoff methods available to the employee, if applicable. */
  availableBalancePayoffMethods?: Maybe<Array<AvailableBalancePayoffMethodCategory>>;
  /** True if this employee can make a transfer. */
  canTransfer: Scalars['Boolean'];
  /** Confirm the requested amount. */
  confirmAdvanceAmount: ConfirmAdvanceAmount;
  /** True if the employee needs to create a payment plan. */
  enableBalancePayoffDisruptor: Scalars['Boolean'];
  /** True if employee can make an instant payment; else button is hidden. */
  instantAvailable: Scalars['Boolean'];
  /** True if instant is enabled for employee; else button is locked. */
  instantEnabled: Scalars['Boolean'];
  /** True if employee can make a next day payment. */
  nextDayAvailable: Scalars['Boolean'];
  /** Where the employee is in the photo ID activation process. */
  photoIdStatus?: Maybe<PhotoIdStatus>;
  /** Return valid transfer amount options in cents for the PayTM. */
  transferAmountOptions?: Maybe<Array<Scalars['Int']>>;
  /** Return fees associated with this transfer. */
  transferFees: TransferFees;
  /** Reason transfers are disabled for this employee. */
  transfersDisabledReason?: Maybe<Scalars['String']>;
  /** True if the employee has one working bank account (non-ADP rise). */
  unlocked: Scalars['Boolean'];
  /** Login URL to v1 employee portal. */
  v1LoginUrl: Scalars['String'];
};


export type PullAdvanceConfirmAdvanceAmountArgs = {
  totalAmountCents: Scalars['Int'];
};

export type PunchCard = {
  __typename?: 'PunchCard';
  /** True if this is the first transfer. */
  first: Scalars['Boolean'];
  /** Number of transfers to show on the punch card. */
  punches: Scalars['Int'];
  /** Number of transfers remaining on the punch card. */
  unpunchedSlots: Scalars['Int'];
};

/** Interface to return a bank account or a debit card for a payment. */
export type ReceivingAccount = {
  /** The account number, last 4 for a debit card. */
  accountNumber: Scalars['String'];
  /** True if this is the user's primary account of this type. */
  checking?: Maybe<Scalars['Boolean']>;
  /** Time and date of when the account was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Primary key for the account. */
  id: Scalars['ID'];
  /** The name of the bank for this account, includes card brand for debit cards. */
  name?: Maybe<Scalars['String']>;
  /** The given nickname of the account. */
  nickname?: Maybe<Scalars['String']>;
  /** The first and last name for this account. This may differ from the name of the employee. */
  ownerName?: Maybe<Scalars['String']>;
  /** True if this is the user's primary account of this type. */
  primary: Scalars['Boolean'];
  /** The type of account (BankAccount or DebitCard). */
  receivingAccountType: Scalars['String'];
  /** Return true if this is a masked/blinded view. */
  restricted: Scalars['Boolean'];
  /** Return true if the user needs to 2-factor authenticate before advancing to this account. */
  twoFactorRequired: Scalars['Boolean'];
};

export type RelatedPayments = {
  __typename?: 'RelatedPayments';
  /** Advances from the next pay period (excluding fees). */
  nextPayPeriodAmountCents: Scalars['Int'];
  /** Advances from other pay periods for this payment (excluding fees). */
  otherTransferAmountCents: Scalars['Int'];
  /** Advances from previous pay periods (excluding fees). */
  previousPayPeriodAmountCents: Scalars['Int'];
  /** fees for this payment from any other pay period */
  totalFeeAmountCents: Scalars['Int'];
};

export type Reward = {
  __typename?: 'Reward';
  /** The datetime that secondary approval was granted. */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The approver for this reward. */
  approver?: Maybe<Employer>;
  /** Campaign name for reward */
  campaignName?: Maybe<Scalars['String']>;
  /** The datetime that the reward was claimed. */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The datetime that the reward was created or updated. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The employee the reward is sent to */
  employee: Employee;
  /** The profile of the employee the reward is sent to */
  employeeProfile: EmployeeProfile;
  /** The date that the reward expires. */
  expiresAtDate: Scalars['ISO8601Date'];
  /** The ID for the reward. */
  id: Scalars['ID'];
  /** Employee-facing note about reward from the provider. */
  notes?: Maybe<Scalars['String']>;
  /** The payment that was created. */
  payment?: Maybe<EmployeePayment>;
  /** The provider associated with this reward. */
  provider: Provider;
  /** Reason for reward */
  reason?: Maybe<RewardReason>;
  /** The employer who requested this reward. */
  requester: Employer;
  /** The reward budget for this reward. */
  rewardBudget: EmployerRewardBudget;
  /** Current status of the reward. */
  status: Scalars['String'];
  /** The thank you note for the reward. */
  thankYouNote?: Maybe<Scalars['String']>;
  /** Total amount of reward in cents. */
  totalAmountCents: Scalars['Int'];
  /** The datetime that the reward was created or updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Reward. */
export type RewardConnection = {
  __typename?: 'RewardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RewardEdge>>>;
  /** A page of Reward objects. */
  items: Array<Reward>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Reward>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RewardEdge = {
  __typename?: 'RewardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Reward>;
};

export type RewardOptions = {
  __typename?: 'RewardOptions';
  /** True if the provider has a positive number of rewards remaining to send. */
  canSendRewards: Scalars['Boolean'];
  /** True if rewards product is enabled for the provider. */
  enableRewards: Scalars['Boolean'];
  /** The maximum allowed monthly budget amount. */
  maxMonthlyBudgetAmountCents: Scalars['Int'];
};

export enum RewardReason {
  /** great performance */
  GreatPerformance = 'GREAT_PERFORMANCE',
  /** shift coverage */
  ShiftCoverage = 'SHIFT_COVERAGE',
  /** work anniversary */
  WorkAnniversary = 'WORK_ANNIVERSARY',
  /** birthday */
  Birthday = 'BIRTHDAY',
  /** other */
  Other = 'OTHER'
}

export type Settlement = {
  __typename?: 'Settlement';
  /** The ID for the settlement. */
  id: Scalars['ID'];
  /** Initial amount of settlement in cents. */
  initialAmountCents: Scalars['Int'];
  /** Currency for initial amount of settlement. */
  initialAmountCurrency: Scalars['String'];
  /** Returns whether the settlement was for a savings product. */
  isSavings: Scalars['Boolean'];
  /** The pay period associated with this settlement. */
  payPeriod: PayPeriod;
  /** The provider associated with this settlement. */
  provider: Provider;
  /** Retained amount of settlement in cents. */
  retainedAmountCents: Scalars['Int'];
  /** The status for the settlement. */
  status: Scalars['String'];
  /** Total amount of settlement in cents. */
  totalAmountCents: Scalars['Int'];
  /** Currency for total amount of settlement in cents. */
  totalAmountCurrency: Scalars['String'];
};

/** The connection type for Settlement. */
export type SettlementConnection = {
  __typename?: 'SettlementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SettlementEdge>>>;
  /** A page of Settlement objects. */
  items: Array<Settlement>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Settlement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SettlementEdge = {
  __typename?: 'SettlementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Settlement>;
};

export type Shift = {
  __typename?: 'Shift';
  /** The date the shift was worked. */
  date?: Maybe<Scalars['ISO8601Date']>;
  /** The total amount earned on this shift before advance rate deduction. */
  earningsCents?: Maybe<Scalars['Int']>;
  /** Returns whether the shift was excluded from the available balance. */
  excluded: Scalars['Boolean'];
  /** The total hours worked for this shift. */
  hours?: Maybe<Scalars['Float']>;
  /** The total amount added to the available balance from this shift. */
  netEarningsCents?: Maybe<Scalars['Int']>;
};

/** The connection type for Shift. */
export type ShiftConnection = {
  __typename?: 'ShiftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShiftEdge>>>;
  /** A page of Shift objects. */
  items: Array<Shift>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Shift>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of results across all pages. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ShiftEdge = {
  __typename?: 'ShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Shift>;
};

export type StrictMimeAttachment = {
  __typename?: 'StrictMimeAttachment';
  /** The filepath of the attachment */
  path?: Maybe<Scalars['String']>;
  /** The AWS direct link with an authorization token */
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SwitchProvider */
export type SwitchProviderPayload = {
  __typename?: 'SwitchProviderPayload';
  /** An updated JWT with the new provider ID. */
  accessToken: Scalars['String'];
  /** The lifetime in seconds of the access token. */
  expiresIn: Scalars['Int'];
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** The type of the token issued (i.e. Bearer). */
  tokenType: Scalars['String'];
};

/** Autogenerated return type of TerminateUser */
export type TerminateUserPayload = {
  __typename?: 'TerminateUserPayload';
  /** The amount of the deduction that should be applied to the last paper check of the user in cents. */
  deductionAmountCents: Scalars['Int'];
  /** The updated employee profile */
  employeeProfile: EmployeeProfile;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Summary of fees for this requested transfer. */
export type TransferFees = {
  __typename?: 'TransferFees';
  /** True if instant fees are waived */
  freeInstant: Scalars['Boolean'];
  /** True if next day fees are waived */
  freeNextDay: Scalars['Boolean'];
  /** True if either instant or next day transfer fees are waived. Next and now fee amounts are still returned. */
  freePull: Scalars['Boolean'];
  /** The date a next day transfer will occur. */
  nextBusinessDay: Scalars['ISO8601DateTime'];
  /** Transfer fees in cents for next day transfer. */
  nextFeeAmountCents: Scalars['Int'];
  /** Transer fees in cents for instant transfer. */
  nowFeeAmountCents: Scalars['Int'];
};

export type TransferReason = {
  __typename?: 'TransferReason';
  /** Primary key for this transfer reason. */
  id: Scalars['ID'];
  /** User specified text for this transfer. */
  reasonText?: Maybe<Scalars['String']>;
  /** User specified type for this transfer (example: bills). */
  reasonType?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateBatchDisbursement */
export type UpdateBatchDisbursementPayload = {
  __typename?: 'UpdateBatchDisbursementPayload';
  /** The newly scheduled disbursement. */
  batchDisbursement: BatchDisbursementFile;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UpdateDisbursement */
export type UpdateDisbursementPayload = {
  __typename?: 'UpdateDisbursementPayload';
  /** The newly scheduled disbursement. */
  disbursement: Disbursement;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Attributes for updating employer notification settings. */
export type UpdateEmployerNotificationSettingsInput = {
  /** Boolean to enable reminder email to activate or cancel currently pending users */
  actionRequiredEmailSubscribed?: Maybe<Scalars['Boolean']>;
  /** Boolean to enable reminder email to upload payroll journal */
  payrollJournalReminderSubscribed?: Maybe<Scalars['Boolean']>;
  /** Boolean to enable off cycle disbursement approvals */
  offCycleDisbursementApprovalSubscribed?: Maybe<Scalars['Boolean']>;
  /** Boolean to enable reminder email to upload earnings */
  earningsReminderSubscribed?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateEmployerNotificationSettings */
export type UpdateEmployerNotificationSettingsPayload = {
  __typename?: 'UpdateEmployerNotificationSettingsPayload';
  /** The updated employer */
  employer: Employer;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

export type UpdateEmployerRewardBudgetInput = {
  /** The employer IDs of the expected approvers for this reward budget. */
  expectedApproverIds?: Maybe<Array<Scalars['ID']>>;
  /** The employer ID for this reward budget. */
  employerId: Scalars['ID'];
  /** Total amount of reward budget in cents. */
  totalAmountCents: Scalars['Int'];
};

/** Autogenerated return type of UpdateEmployerRewardBudget */
export type UpdateEmployerRewardBudgetPayload = {
  __typename?: 'UpdateEmployerRewardBudgetPayload';
  /** The newly created budget. */
  employerRewardBudget: EmployerRewardBudget;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UpdateManagerStatus */
export type UpdateManagerStatusPayload = {
  __typename?: 'UpdateManagerStatusPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UpdateReward */
export type UpdateRewardPayload = {
  __typename?: 'UpdateRewardPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** The newly approved reward. */
  reward: Reward;
};

/** Attributes for updating an employee's final net pay. */
export type UpdateUserFinalPayInput = {
  /** How the final pay will be collected. */
  finalPayType: FinalPay;
  /** The final net pay in cents that the worker will receive after all non-DailyPay deductions. */
  netPayCents: Scalars['Int'];
  /** The gross pay in cents that the worker will receive before all non-DailyPay deductions. */
  grossPayCents?: Maybe<Scalars['Int']>;
  /** The total of all DailyPay and non-DailyPay deductions. */
  deductionAmountCents?: Maybe<Scalars['Int']>;
  /** The provider account ID to update. */
  providerAccountId?: Maybe<Scalars['ID']>;
  /** The employer profile ID to update. */
  employeeProfileId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UpdateUserFinalPay */
export type UpdateUserFinalPayPayload = {
  __typename?: 'UpdateUserFinalPayPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UpdateUserStatus */
export type UpdateUserStatusPayload = {
  __typename?: 'UpdateUserStatusPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** The updated provider account. */
  providerAccount: ProviderAccount;
};


/** Autogenerated return type of UploadBatchDisbursement */
export type UploadBatchDisbursementPayload = {
  __typename?: 'UploadBatchDisbursementPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UploadBatchOnboard */
export type UploadBatchOnboardPayload = {
  __typename?: 'UploadBatchOnboardPayload';
  /** Batch Onboard (User Roster) file upload */
  batchOnboardFile: BatchOnboardFile;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UploadGrossEarnings */
export type UploadGrossEarningsPayload = {
  __typename?: 'UploadGrossEarningsPayload';
  /** Gross Earnings file upload */
  grossEarningsTransmissionFile: GrossEarningsTransmissionFile;
  /** An informational message about this user update. */
  message: Scalars['String'];
};

/** Autogenerated return type of UploadPayrollJournal */
export type UploadPayrollJournalPayload = {
  __typename?: 'UploadPayrollJournalPayload';
  /** An informational message about this user update. */
  message: Scalars['String'];
  /** Payroll Journal (Net Earnings) file upload */
  payrollJournalFile: PayrollJournalFile;
};

export type User = {
  __typename?: 'User';
  /** Custom instructions for SSO. */
  customSsoInstructions?: Maybe<Scalars['String']>;
  /** The email of the user. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']>;
  /** Primary key for the user. */
  id: Scalars['ID'];
  /** The two character locale for the user. Default EN. */
  languagePreference: LanguagePreference;
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']>;
  /** The obfuscated telephone number for the user. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Providers associated with this user. */
  providers: ProviderConnection;
};


export type UserProvidersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type CreateDirectDepositUpdateFileMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDirectDepositUpdateFileMutation = (
  { __typename?: 'PartnersMutation' }
  & { createDirectDepositUpdateFile: (
    { __typename?: 'CreateDirectDepositUpdateFilePayload' }
    & Pick<CreateDirectDepositUpdateFilePayload, 'message'>
    & { directDepositUpdateFile: (
      { __typename?: 'DirectDepositUpdateFile' }
      & { attachment?: Maybe<(
        { __typename?: 'Attachment' }
        & Pick<Attachment, 'url'>
      )> }
    ) }
  ) }
);

export type CreateDisbursementMutationVariables = Exact<{
  input: CreateDisbursementInput;
}>;


export type CreateDisbursementMutation = (
  { __typename?: 'PartnersMutation' }
  & { createDisbursement: (
    { __typename?: 'CreateDisbursementPayload' }
    & Pick<CreateDisbursementPayload, 'message'>
    & { disbursement?: Maybe<(
      { __typename?: 'Disbursement' }
      & Pick<Disbursement, 'reason' | 'totalAmountCents'>
      & { user: (
        { __typename?: 'ProviderAccount' }
        & Pick<ProviderAccount, 'id'>
      ) }
    )> }
  ) }
);

export type CreateManagerMutationVariables = Exact<{
  createManagerInput: CreateManagerInput;
}>;


export type CreateManagerMutation = (
  { __typename?: 'PartnersMutation' }
  & { createManager: (
    { __typename?: 'CreateManagerPayload' }
    & Pick<CreateManagerPayload, 'message'>
    & { managers: Array<(
      { __typename?: 'Manager' }
      & Pick<Manager, 'id' | 'firstName' | 'lastName' | 'employerId'>
    )> }
  ) }
);

export type CreatePartnerReportMutationVariables = Exact<{
  reportType: PartnerReport;
}>;


export type CreatePartnerReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { createPartnerReport: (
    { __typename?: 'CreatePartnerReportPayload' }
    & Pick<CreatePartnerReportPayload, 'message'>
  ) }
);

export type CreateRewardMutationVariables = Exact<{
  createRewardInput: CreateRewardInput;
}>;


export type CreateRewardMutation = (
  { __typename?: 'PartnersMutation' }
  & { createReward: (
    { __typename?: 'CreateRewardPayload' }
    & Pick<CreateRewardPayload, 'message'>
  ) }
);

export type EnableSmsOnboardingMutationVariables = Exact<{
  pendingUserSmsAllowed: Scalars['Boolean'];
}>;


export type EnableSmsOnboardingMutation = (
  { __typename?: 'PartnersMutation' }
  & { enableSmsOnboarding: (
    { __typename?: 'EnableSmsOnboardingPayload' }
    & Pick<EnableSmsOnboardingPayload, 'message'>
  ) }
);

export type ExportPayrollExtenderReportMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportPayrollExtenderReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { exportPayrollExtenderReport: (
    { __typename?: 'ExportPayrollExtenderReportPayload' }
    & Pick<ExportPayrollExtenderReportPayload, 'message'>
  ) }
);

export type ExportCashBalanceReportMutationVariables = Exact<{
  payPeriodEndsAtDate: Scalars['ISO8601Date'];
}>;


export type ExportCashBalanceReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { exportCashBalanceReport: (
    { __typename?: 'ExportCashBalanceReportPayload' }
    & Pick<ExportCashBalanceReportPayload, 'message'>
  ) }
);

export type ExportDduConsentReportMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportDduConsentReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { exportDduConsentReport: (
    { __typename?: 'ExportDduConsentReportPayload' }
    & Pick<ExportDduConsentReportPayload, 'message'>
  ) }
);

export type ExportPaystubReportMutationVariables = Exact<{
  payPeriodEndsAtDate?: Maybe<Scalars['ISO8601Date']>;
}>;


export type ExportPaystubReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { exportPaystubReport: (
    { __typename?: 'ExportPaystubReportPayload' }
    & Pick<ExportPaystubReportPayload, 'message'>
  ) }
);

export type ExportPresettlementExclusionReportMutationVariables = Exact<{
  paymentExpectedOn: Scalars['ISO8601Date'];
}>;


export type ExportPresettlementExclusionReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { exportPresettlementExclusionReport: (
    { __typename?: 'ExportPresettlementExclusionReportPayload' }
    & Pick<ExportPresettlementExclusionReportPayload, 'message'>
  ) }
);

export type GenerateBatchOnboardUrlMutationVariables = Exact<{
  batchOnboardId: Scalars['ID'];
}>;


export type GenerateBatchOnboardUrlMutation = (
  { __typename?: 'PartnersMutation' }
  & { generateBatchOnboardUrl: (
    { __typename?: 'GenerateBatchOnboardUrlPayload' }
    & Pick<GenerateBatchOnboardUrlPayload, 'batchOnboardUrl' | 'message'>
  ) }
);

export type GenerateDduReportMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateDduReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { generateDduReportUrl: (
    { __typename?: 'GenerateDduReportUrlPayload' }
    & Pick<GenerateDduReportUrlPayload, 'reportUrl' | 'message'>
  ) }
);

export type GeneratePartnerReportMutationVariables = Exact<{
  reportType: PartnerReport;
}>;


export type GeneratePartnerReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { generatePartnerReportUrl: (
    { __typename?: 'GeneratePartnerReportUrlPayload' }
    & Pick<GeneratePartnerReportUrlPayload, 'reportUrl' | 'message'>
  ) }
);

export type GeneratePayrollAnomalyReportMutationVariables = Exact<{
  payrollJournalId: Scalars['ID'];
}>;


export type GeneratePayrollAnomalyReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { generatePayrollAnomalyReportUrl: (
    { __typename?: 'GeneratePayrollAnomalyReportUrlPayload' }
    & Pick<GeneratePayrollAnomalyReportUrlPayload, 'reportUrl'>
  ) }
);

export type GenerateRewardsReportMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateRewardsReportMutation = (
  { __typename?: 'PartnersMutation' }
  & { generateRewardsReportUrl: (
    { __typename?: 'GenerateRewardsReportUrlPayload' }
    & Pick<GenerateRewardsReportUrlPayload, 'reportUrl'>
  ) }
);

export type SwitchProviderMutationVariables = Exact<{
  providerId: Scalars['ID'];
}>;


export type SwitchProviderMutation = (
  { __typename?: 'PartnersMutation' }
  & { switchProvider: (
    { __typename?: 'SwitchProviderPayload' }
    & Pick<SwitchProviderPayload, 'accessToken' | 'expiresIn' | 'message' | 'tokenType'>
  ) }
);

export type TerminateUserMutationVariables = Exact<{
  employeeProfileId: Scalars['ID'];
}>;


export type TerminateUserMutation = (
  { __typename?: 'PartnersMutation' }
  & { terminateUser: (
    { __typename?: 'TerminateUserPayload' }
    & Pick<TerminateUserPayload, 'deductionAmountCents'>
  ) }
);

export type UpdateBatchDisbursementMutationVariables = Exact<{
  approved: Scalars['Boolean'];
  batchDisbursementId: Scalars['ID'];
}>;


export type UpdateBatchDisbursementMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateBatchDisbursement: (
    { __typename?: 'UpdateBatchDisbursementPayload' }
    & Pick<UpdateBatchDisbursementPayload, 'message'>
    & { batchDisbursement: (
      { __typename?: 'BatchDisbursementFile' }
      & Pick<BatchDisbursementFile, 'id' | 'status'>
    ) }
  ) }
);

export type UpdateDisbursementMutationVariables = Exact<{
  approved: Scalars['Boolean'];
  disbursementId: Scalars['ID'];
}>;


export type UpdateDisbursementMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateDisbursement: (
    { __typename?: 'UpdateDisbursementPayload' }
    & Pick<UpdateDisbursementPayload, 'message'>
    & { disbursement: (
      { __typename?: 'Disbursement' }
      & Pick<Disbursement, 'id' | 'status' | 'disbursementReceivedOn' | 'canApprove'>
    ) }
  ) }
);

export type UpdateEmployerNotificationSettingsMutationVariables = Exact<{
  input: UpdateEmployerNotificationSettingsInput;
}>;


export type UpdateEmployerNotificationSettingsMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateEmployerNotificationSettings: (
    { __typename?: 'UpdateEmployerNotificationSettingsPayload' }
    & Pick<UpdateEmployerNotificationSettingsPayload, 'message'>
    & { employer: (
      { __typename?: 'Employer' }
      & Pick<Employer, 'id' | 'firstName' | 'lastName'>
      & { employerNotificationSettings: (
        { __typename?: 'EmployerNotificationSettings' }
        & Pick<EmployerNotificationSettings, 'payrollJournalReminderSubscribed' | 'actionRequiredEmailSubscribed' | 'earningsReminderSubscribed' | 'offCycleDisbursementApprovalSubscribed'>
      ) }
    ) }
  ) }
);

export type UpdateEmployerRewardBudgetMutationVariables = Exact<{
  updateEmployerRewardBudgetInput: UpdateEmployerRewardBudgetInput;
}>;


export type UpdateEmployerRewardBudgetMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateEmployerRewardBudget: (
    { __typename?: 'UpdateEmployerRewardBudgetPayload' }
    & { employerRewardBudget: (
      { __typename?: 'EmployerRewardBudget' }
      & Pick<EmployerRewardBudget, 'id' | 'totalAmountCents'>
      & { expectedApprovers?: Maybe<Array<(
        { __typename?: 'Employer' }
        & Pick<Employer, 'id' | 'firstName' | 'lastName'>
      )>>, employer: (
        { __typename?: 'Employer' }
        & Pick<Employer, 'id' | 'firstName' | 'lastName'>
      ) }
    ) }
  ) }
);

export type UpdateManagerStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type UpdateManagerStatusMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateManagerStatus: (
    { __typename?: 'UpdateManagerStatusPayload' }
    & Pick<UpdateManagerStatusPayload, 'message'>
  ) }
);

export type UpdateRewardMutationVariables = Exact<{
  approved: Scalars['Boolean'];
  rewardId: Scalars['ID'];
  approverId: Scalars['ID'];
}>;


export type UpdateRewardMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateReward: (
    { __typename?: 'UpdateRewardPayload' }
    & Pick<UpdateRewardPayload, 'message'>
    & { reward: (
      { __typename?: 'Reward' }
      & Pick<Reward, 'id' | 'status' | 'approvedAt'>
      & { approver?: Maybe<(
        { __typename?: 'Employer' }
        & Pick<Employer, 'id' | 'firstName' | 'lastName'>
      )> }
    ) }
  ) }
);

export type UpdateUserFinalPayMutationVariables = Exact<{
  input: UpdateUserFinalPayInput;
}>;


export type UpdateUserFinalPayMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateUserFinalPay: (
    { __typename?: 'UpdateUserFinalPayPayload' }
    & Pick<UpdateUserFinalPayPayload, 'message'>
  ) }
);

export type UpdateUserStatusMutationVariables = Exact<{
  providerAccountId: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
}>;


export type UpdateUserStatusMutation = (
  { __typename?: 'PartnersMutation' }
  & { updateUserStatus: (
    { __typename?: 'UpdateUserStatusPayload' }
    & Pick<UpdateUserStatusPayload, 'message'>
  ) }
);

export type UploadBatchDisbursementMutationVariables = Exact<{
  input: FileUploadInput;
  reason: DisbursementReasonCategory;
}>;


export type UploadBatchDisbursementMutation = (
  { __typename?: 'PartnersMutation' }
  & { uploadBatchDisbursement: (
    { __typename?: 'UploadBatchDisbursementPayload' }
    & Pick<UploadBatchDisbursementPayload, 'message'>
  ) }
);

export type UploadBatchOnboardMutationVariables = Exact<{
  uploadBatchOnboardInput: FileUploadInput;
}>;


export type UploadBatchOnboardMutation = (
  { __typename?: 'PartnersMutation' }
  & { uploadBatchOnboard: (
    { __typename?: 'UploadBatchOnboardPayload' }
    & Pick<UploadBatchOnboardPayload, 'message'>
  ) }
);

export type UploadGrossEarningsMutationVariables = Exact<{
  uploadGrossEarningsInput: FileUploadInput;
}>;


export type UploadGrossEarningsMutation = (
  { __typename?: 'PartnersMutation' }
  & { uploadGrossEarnings: (
    { __typename?: 'UploadGrossEarningsPayload' }
    & Pick<UploadGrossEarningsPayload, 'message'>
  ) }
);

export type UploadPayrollJournalMutationVariables = Exact<{
  uploadPayrollJournalInput: FileUploadInput;
}>;


export type UploadPayrollJournalMutation = (
  { __typename?: 'PartnersMutation' }
  & { uploadPayrollJournal: (
    { __typename?: 'UploadPayrollJournalPayload' }
    & Pick<UploadPayrollJournalPayload, 'message'>
  ) }
);

export type GetAdminsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
}>;


export type GetAdminsQuery = (
  { __typename?: 'PartnersQuery' }
  & { managers: (
    { __typename?: 'ManagerConnection' }
    & Pick<ManagerConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'Manager' }
      & Pick<Manager, 'id' | 'employerId' | 'firstName' | 'lastName' | 'email' | 'payGroup' | 'permissions' | 'status' | 'ether'>
      & { locations: (
        { __typename?: 'ProviderLocationConnection' }
        & Pick<ProviderLocationConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'ProviderLocation' }
          & Pick<ProviderLocation, 'id' | 'name'>
        )> }
      ) }
    )> }
  ) }
);

export type GetApiResponseLogsQueryVariables = Exact<{
  logCategory: ApiResponseLogCategory;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetApiResponseLogsQuery = (
  { __typename?: 'PartnersQuery' }
  & { apiResponseLogs: (
    { __typename?: 'ApiResponseLogConnection' }
    & Pick<ApiResponseLogConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'ApiResponseLog' }
      & Pick<ApiResponseLog, 'request' | 'response' | 'createdAt'>
    )> }
  ) }
);

export type AssociatedLocationsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type AssociatedLocationsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { associatedLocations: (
      { __typename?: 'ProviderLocationConnection' }
      & Pick<ProviderLocationConnection, 'totalCount'>
      & { items: Array<(
        { __typename?: 'ProviderLocation' }
        & Pick<ProviderLocation, 'id' | 'name'>
      )> }
    ) }
  ) }
);

export type GetBalanceDistributorReportQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetBalanceDistributorReportQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id' | 'name'>
      & { employeesEnrolledInPayrollExtender?: Maybe<(
        { __typename?: 'EmployeeProfileConnection' }
        & Pick<EmployeeProfileConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'EmployeeProfile' }
          & Pick<EmployeeProfile, 'location' | 'payGroups'>
          & { employee: (
            { __typename?: 'Employee' }
            & Pick<Employee, 'firstName' | 'lastName'>
          ), externalIds: Array<(
            { __typename?: 'ExternalId' }
            & Pick<ExternalId, 'id' | 'kind'>
          )> }
        )> }
      )> }
    ) }
  ) }
);

export type GetBatchDisbursementsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetBatchDisbursementsQuery = (
  { __typename?: 'PartnersQuery' }
  & { batchDisbursements?: Maybe<(
    { __typename?: 'BatchDisbursementFileConnection' }
    & Pick<BatchDisbursementFileConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'BatchDisbursementFile' }
      & Pick<BatchDisbursementFile, 'id' | 'createdAt' | 'originalFilename' | 'status'>
      & { requester: (
        { __typename?: 'Employer' }
        & Pick<Employer, 'id' | 'firstName' | 'lastName'>
      ), attachment: (
        { __typename?: 'Attachment' }
        & Pick<Attachment, 'path' | 'url'>
      ), errorsAttachment?: Maybe<(
        { __typename?: 'Attachment' }
        & Pick<Attachment, 'path' | 'url'>
      )> }
    )> }
  )> }
);

export type GetCashBalanceReportsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  endsAtDate?: Maybe<Scalars['String']>;
}>;


export type GetCashBalanceReportsQuery = (
  { __typename?: 'PartnersQuery' }
  & { complianceReports: (
    { __typename?: 'ComplianceReports' }
    & { cashBalanceReports: (
      { __typename?: 'PayPeriodConnection' }
      & Pick<PayPeriodConnection, 'totalCount'>
      & { items: Array<(
        { __typename?: 'PayPeriod' }
        & Pick<PayPeriod, 'id' | 'endsAtDate' | 'providerAccountExternalId'>
        & { company: (
          { __typename?: 'ProviderCompany' }
          & Pick<ProviderCompany, 'id' | 'payGroup'>
        ), summary: (
          { __typename?: 'PayPeriodSummary' }
          & Pick<PayPeriodSummary, 'negativeBalancePaidSettlementAmountCents' | 'netEarningsAmountCents' | 'totalTransferredEarlyAmountCents' | 'remainderAmountCents'>
        ) }
      )> }
    ) }
  ) }
);

export type GetDduConsentReportsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetDduConsentReportsQuery = (
  { __typename?: 'PartnersQuery' }
  & { complianceReports: (
    { __typename?: 'ComplianceReports' }
    & { directDepositUpdateConsentReports: (
      { __typename?: 'ProviderAccountConnection' }
      & Pick<ProviderAccountConnection, 'totalCount'>
      & { items: Array<(
        { __typename?: 'ProviderAccount' }
        & Pick<ProviderAccount, 'id' | 'externalId' | 'firstAdvanceCreatedAt' | 'status'>
        & { company: (
          { __typename?: 'ProviderCompany' }
          & Pick<ProviderCompany, 'id' | 'payGroup'>
        ), employee: (
          { __typename?: 'Employee' }
          & Pick<Employee, 'id' | 'termsAcceptedAt'>
        ) }
      )> }
    ) }
  ) }
);

export type GetDirectDepositFilesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetDirectDepositFilesQuery = (
  { __typename?: 'PartnersQuery' }
  & { directDepositUpdateFiles: (
    { __typename?: 'DirectDepositUpdateFileConnection' }
    & Pick<DirectDepositUpdateFileConnection, 'pendingUpdateCount' | 'totalCount'>
    & { items: Array<(
      { __typename?: 'DirectDepositUpdateFile' }
      & Pick<DirectDepositUpdateFile, 'id' | 'createdAt'>
      & { attachment?: Maybe<(
        { __typename?: 'Attachment' }
        & Pick<Attachment, 'path' | 'url'>
      )>, creator: (
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
      ) }
    )> }
  ) }
);

export type GetDisbursementsRequestersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDisbursementsRequestersQuery = (
  { __typename?: 'PartnersQuery' }
  & { managers: (
    { __typename?: 'ManagerConnection' }
    & Pick<ManagerConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'Manager' }
      & Pick<Manager, 'id' | 'employerId' | 'firstName' | 'lastName'>
    )> }
  ) }
);

export type GetEmployeeDisbursementsQueryVariables = Exact<{
  employeeProfileId: Scalars['ID'];
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetEmployeeDisbursementsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employeeProfile: (
    { __typename?: 'EmployeeProfile' }
    & Pick<EmployeeProfile, 'id'>
    & { disbursements: (
      { __typename?: 'DisbursementConnection' }
      & Pick<DisbursementConnection, 'totalCount'>
      & { items: Array<(
        { __typename?: 'Disbursement' }
        & Pick<Disbursement, 'id' | 'status' | 'reason' | 'totalAmountCents' | 'feeAmountCents' | 'notes' | 'createdAt' | 'disbursementReceivedOn' | 'canApprove'>
        & { userBankAccount: (
          { __typename?: 'BankAccount' }
          & Pick<BankAccount, 'id' | 'accountNumber' | 'name'>
        ) | (
          { __typename?: 'DebitCard' }
          & Pick<DebitCard, 'id' | 'accountNumber' | 'name'>
        ) }
      )> }
    ) }
  ) }
);

export type EmployeeProfileQueryVariables = Exact<{
  employeeProfileId: Scalars['ID'];
}>;


export type EmployeeProfileQuery = (
  { __typename?: 'PartnersQuery' }
  & { employeeProfile: (
    { __typename?: 'EmployeeProfile' }
    & Pick<EmployeeProfile, 'id' | 'partnerCanceledAt' | 'dpaOnFile'>
    & { externalIds: Array<(
      { __typename?: 'ExternalId' }
      & Pick<ExternalId, 'id' | 'kind' | 'primary'>
    )>, employee: (
      { __typename?: 'Employee' }
      & Pick<Employee, 'id' | 'firstName' | 'lastName' | 'email' | 'hasPlaceholderEmail' | 'termsAccepted' | 'phoneNumber' | 'userStatus' | 'knownTrackingId'>
      & { currentPayPeriodSummary: (
        { __typename?: 'CurrentPayPeriodSummary' }
        & Pick<CurrentPayPeriodSummary, 'availableBalanceCents'>
      ), providerBankAccount?: Maybe<(
        { __typename?: 'BankAccount' }
        & Pick<BankAccount, 'id' | 'accountNumber' | 'routingNumber' | 'createdAt' | 'restricted' | 'receivingAccountType'>
      )>, userBankAccounts?: Maybe<(
        { __typename?: 'BankAccountConnection' }
        & { items: Array<(
          { __typename?: 'BankAccount' }
          & Pick<BankAccount, 'id' | 'accountNumber' | 'routingNumber' | 'createdAt' | 'name' | 'primary' | 'creditable' | 'restricted' | 'receivingAccountType'>
        )> }
      )>, providers: (
        { __typename?: 'ProviderConnection' }
        & Pick<ProviderConnection, 'totalCount'>
      ) }
    ), providerAccounts: (
      { __typename?: 'ProviderAccountConnection' }
      & { items: Array<(
        { __typename?: 'ProviderAccount' }
        & Pick<ProviderAccount, 'id' | 'status'>
        & { company: (
          { __typename?: 'ProviderCompany' }
          & Pick<ProviderCompany, 'id' | 'payGroup'>
        ), payPeriods?: Maybe<(
          { __typename?: 'PayPeriodConnection' }
          & { items: Array<(
            { __typename?: 'PayPeriod' }
            & Pick<PayPeriod, 'id' | 'name' | 'startsAt' | 'endsAt'>
          )> }
        )> }
      )> }
    ) }
  ) }
);

export type EmployeeProfilesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  userStatus?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<Scalars['String']>;
  locationIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  benefitType?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
}>;


export type EmployeeProfilesQuery = (
  { __typename?: 'PartnersQuery' }
  & { employeeProfiles: (
    { __typename?: 'EmployeeProfileConnection' }
    & Pick<EmployeeProfileConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'EmployeeProfile' }
      & Pick<EmployeeProfile, 'id' | 'partnerCanceledAt'>
      & { employeeLocation?: Maybe<(
        { __typename?: 'ProviderLocation' }
        & Pick<ProviderLocation, 'id' | 'name'>
      )>, employee: (
        { __typename?: 'Employee' }
        & Pick<Employee, 'id' | 'email' | 'firstName' | 'lastName' | 'phoneNumber' | 'userStatus' | 'usingWisely'>
      ), externalIds: Array<(
        { __typename?: 'ExternalId' }
        & Pick<ExternalId, 'id' | 'kind' | 'primary'>
      )>, providerAccounts: (
        { __typename?: 'ProviderAccountConnection' }
        & { items: Array<(
          { __typename?: 'ProviderAccount' }
          & { company: (
            { __typename?: 'ProviderCompany' }
            & Pick<ProviderCompany, 'id' | 'payGroup'>
          ) }
        )> }
      ) }
    )> }
  ) }
);

export type GetEmployeeRewardsQueryVariables = Exact<{
  employeeProfileId: Scalars['ID'];
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetEmployeeRewardsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employeeProfile: (
    { __typename?: 'EmployeeProfile' }
    & Pick<EmployeeProfile, 'id'>
    & { employee: (
      { __typename?: 'Employee' }
      & Pick<Employee, 'id'>
      & { rewards: (
        { __typename?: 'RewardConnection' }
        & Pick<RewardConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'Reward' }
          & Pick<Reward, 'id' | 'createdAt' | 'totalAmountCents' | 'status' | 'reason'>
          & { requester: (
            { __typename?: 'Employer' }
            & Pick<Employer, 'id' | 'firstName' | 'lastName'>
          ), approver?: Maybe<(
            { __typename?: 'Employer' }
            & Pick<Employer, 'id' | 'firstName' | 'lastName'>
          )>, rewardBudget: (
            { __typename?: 'EmployerRewardBudget' }
            & { expectedApprovers?: Maybe<Array<(
              { __typename?: 'Employer' }
              & Pick<Employer, 'id' | 'firstName' | 'lastName'>
            )>> }
          ) }
        )> }
      ) }
    ) }
  ) }
);

export type GetEmployerDetailsQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type GetEmployerDetailsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id'>
      & { employers: (
        { __typename?: 'EmployerConnection' }
        & { items: Array<(
          { __typename?: 'Employer' }
          & Pick<Employer, 'id' | 'firstName' | 'lastName' | 'email' | 'permissions' | 'workPhoneNumber'>
          & { associatedLocations: (
            { __typename?: 'ProviderLocationConnection' }
            & { items: Array<(
              { __typename?: 'ProviderLocation' }
              & Pick<ProviderLocation, 'id' | 'name'>
            )> }
          ), employerRewardBudget: (
            { __typename?: 'EmployerRewardBudget' }
            & Pick<EmployerRewardBudget, 'id'>
          ) }
        )> }
      ) }
    ) }
  ) }
);

export type GetEmployerNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployerNotificationSettingsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id' | 'firstName' | 'lastName'>
    & { employerNotificationSettings: (
      { __typename?: 'EmployerNotificationSettings' }
      & Pick<EmployerNotificationSettings, 'payrollJournalReminderSubscribed' | 'actionRequiredEmailSubscribed' | 'earningsReminderSubscribed' | 'offCycleDisbursementApprovalSubscribed'>
    ) }
  ) }
);

export type GetEmployersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetEmployersQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id'>
      & { employers: (
        { __typename?: 'EmployerConnection' }
        & Pick<EmployerConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'Employer' }
          & Pick<Employer, 'id' | 'firstName' | 'lastName'>
        )> }
      ) }
    ) }
  ) }
);

export type GetGrossEarningsTransmissionsFilesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetGrossEarningsTransmissionsFilesQuery = (
  { __typename?: 'PartnersQuery' }
  & { grossEarningsTransmissionFiles?: Maybe<(
    { __typename?: 'GrossEarningsTransmissionFileConnection' }
    & Pick<GrossEarningsTransmissionFileConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'GrossEarningsTransmissionFile' }
      & Pick<GrossEarningsTransmissionFile, 'id' | 'status' | 'createdAt' | 'originalFilename'>
      & { attachment?: Maybe<(
        { __typename?: 'Attachment' }
        & Pick<Attachment, 'path' | 'url'>
      )>, manager: (
        { __typename?: 'Manager' }
        & Pick<Manager, 'id' | 'firstName' | 'lastName'>
      ) }
    )> }
  )> }
);

export type GetLatestPayrollAnomaliesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestPayrollAnomaliesCountQuery = (
  { __typename?: 'PartnersQuery' }
  & { payrollJournalFiles?: Maybe<(
    { __typename?: 'PayrollJournalFileConnection' }
    & { items: Array<(
      { __typename?: 'PayrollJournalFile' }
      & Pick<PayrollJournalFile, 'id' | 'supportsAnomalyReport'>
      & { anomalyReport?: Maybe<(
        { __typename?: 'PayrollAnomalyReport' }
        & { outliers: (
          { __typename?: 'PayrollAnomalyReportOutlierConnection' }
          & Pick<PayrollAnomalyReportOutlierConnection, 'totalCount'>
        ) }
      )> }
    )> }
  )> }
);

export type MetabaseDashboardTokenQueryVariables = Exact<{
  dashboard?: Maybe<MetabaseDashboardToken>;
}>;


export type MetabaseDashboardTokenQuery = (
  { __typename?: 'PartnersQuery' }
  & Pick<PartnersQuery, 'metabaseDashboardToken'>
);

export type GetNetEarningsFilesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetNetEarningsFilesQuery = (
  { __typename?: 'PartnersQuery' }
  & { payrollJournalFiles?: Maybe<(
    { __typename?: 'PayrollJournalFileConnection' }
    & Pick<PayrollJournalFileConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'PayrollJournalFile' }
      & Pick<PayrollJournalFile, 'id' | 'status' | 'createdAt' | 'supportsAnomalyReport'>
      & { creator: (
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
      ), attachment?: Maybe<(
        { __typename?: 'StrictMimeAttachment' }
        & Pick<StrictMimeAttachment, 'path' | 'url'>
      )> }
    )> }
  )> }
);

export type GetOperatingManagersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetOperatingManagersQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id'>
      & { employerRewardBudgets: (
        { __typename?: 'EmployerRewardBudgetConnection' }
        & Pick<EmployerRewardBudgetConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'EmployerRewardBudget' }
          & Pick<EmployerRewardBudget, 'id' | 'totalAmountCents'>
          & { expectedApprovers?: Maybe<Array<(
            { __typename?: 'Employer' }
            & Pick<Employer, 'id' | 'firstName' | 'lastName'>
          )>>, employer: (
            { __typename?: 'Employer' }
            & Pick<Employer, 'id' | 'firstName' | 'lastName' | 'email' | 'permissions' | 'workPhoneNumber'>
            & { associatedLocations: (
              { __typename?: 'ProviderLocationConnection' }
              & Pick<ProviderLocationConnection, 'totalCount'>
              & { items: Array<(
                { __typename?: 'ProviderLocation' }
                & Pick<ProviderLocation, 'id' | 'name'>
              )> }
            ) }
          ) }
        )> }
      ) }
    ) }
  ) }
);

export type GetPartnerRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerRolesQuery = (
  { __typename?: 'PartnersQuery' }
  & { partnerRoles: (
    { __typename?: 'PartnerRoleConnection' }
    & Pick<PartnerRoleConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'PartnerRole' }
      & Pick<PartnerRole, 'oid' | 'description'>
    )> }
  ) }
);

export type GetPayPeriodQueryVariables = Exact<{
  payPeriodId: Scalars['ID'];
  employeeProfileId: Scalars['ID'];
  providerAccountId: Scalars['ID'];
}>;


export type GetPayPeriodQuery = (
  { __typename?: 'PartnersQuery' }
  & { employeeProfile: (
    { __typename?: 'EmployeeProfile' }
    & Pick<EmployeeProfile, 'id'>
    & { providerAccount: (
      { __typename?: 'ProviderAccount' }
      & Pick<ProviderAccount, 'id'>
      & { payPeriod: (
        { __typename?: 'PayPeriod' }
        & Pick<PayPeriod, 'id' | 'startsAt' | 'endsAt' | 'name'>
        & { summary: (
          { __typename?: 'PayPeriodSummary' }
          & Pick<PayPeriodSummary, 'netEarningsAmountCents' | 'remainderAmountCents' | 'totalFeeAmountCents' | 'totalTransferredEarlyAmountCents' | 'negativeBalancePaidSettlementAmountCents'>
        ), employeePayments: (
          { __typename?: 'EmployeePaymentConnection' }
          & { items: Array<(
            { __typename?: 'EmployeePayment' }
            & Pick<EmployeePayment, 'id' | 'processedOn' | 'paymentType' | 'payPeriodAmountCents' | 'paymentMethod' | 'feeAmountCents'>
            & { receivingAccount?: Maybe<(
              { __typename?: 'BankAccount' }
              & Pick<BankAccount, 'accountNumber' | 'name' | 'receivingAccountType'>
            ) | (
              { __typename?: 'DebitCard' }
              & Pick<DebitCard, 'accountNumber' | 'name' | 'receivingAccountType'>
            )>, relatedPayments?: Maybe<(
              { __typename?: 'RelatedPayments' }
              & Pick<RelatedPayments, 'nextPayPeriodAmountCents' | 'previousPayPeriodAmountCents' | 'otherTransferAmountCents' | 'totalFeeAmountCents'>
            )> }
          )> }
        ), providerPayments: (
          { __typename?: 'ProviderPaymentConnection' }
          & { items: Array<(
            { __typename?: 'ProviderPayment' }
            & Pick<ProviderPayment, 'id' | 'processedOn' | 'accountNumber' | 'totalAmountCents'>
          )> }
        ) }
      ) }
    ) }
  ) }
);

export type GetPayPeriodEndDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayPeriodEndDatesQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id' | 'payPeriodEndDates'>
    ) }
  ) }
);

export type GetPayPeriodPaymentExpectedOnDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayPeriodPaymentExpectedOnDatesQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id' | 'payPeriodPaymentExpectedOnDates'>
    ) }
  ) }
);

export type GetPayrollAnomalyDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollAnomalyDetailsQuery = (
  { __typename?: 'PartnersQuery' }
  & { payrollJournalFile?: Maybe<(
    { __typename?: 'PayrollJournalFile' }
    & Pick<PayrollJournalFile, 'id' | 'supportsAnomalyReport' | 'originalFilename' | 'createdAt'>
    & { anomalyReport?: Maybe<(
      { __typename?: 'PayrollAnomalyReport' }
      & { stats: (
        { __typename?: 'PayrollAnomalyReportStats' }
        & Pick<PayrollAnomalyReportStats, 'netPayMinimum' | 'netPayMaximum' | 'netPayMean' | 'netPaySum' | 'lineCount' | 'employeeCount' | 'missingEmployeeCount' | 'missingNetPayCount' | 'duplicateEmployeeCount' | 'duplicateLineCount'>
      ) }
    )> }
  )> }
);

export type GetPayrollAnomalyOutliersQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetPayrollAnomalyOutliersQuery = (
  { __typename?: 'PartnersQuery' }
  & { payrollJournalFile?: Maybe<(
    { __typename?: 'PayrollJournalFile' }
    & Pick<PayrollJournalFile, 'id'>
    & { anomalyReport?: Maybe<(
      { __typename?: 'PayrollAnomalyReport' }
      & { outliers: (
        { __typename?: 'PayrollAnomalyReportOutlierConnection' }
        & Pick<PayrollAnomalyReportOutlierConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'PayrollAnomalyReportOutlier' }
          & Pick<PayrollAnomalyReportOutlier, 'firstName' | 'lastName' | 'externalId' | 'netPay' | 'netPayMean' | 'deviationFromMean'>
        )> }
      ) }
    )> }
  )> }
);

export type GetPaystubReportsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  endsAtDate?: Maybe<Scalars['String']>;
}>;


export type GetPaystubReportsQuery = (
  { __typename?: 'PartnersQuery' }
  & { complianceReports: (
    { __typename?: 'ComplianceReports' }
    & { paystubReports: (
      { __typename?: 'PayPeriodConnection' }
      & Pick<PayPeriodConnection, 'totalCount'>
      & { items: Array<(
        { __typename?: 'PayPeriod' }
        & Pick<PayPeriod, 'id' | 'endsAtDate' | 'providerAccountExternalId'>
        & { company: (
          { __typename?: 'ProviderCompany' }
          & Pick<ProviderCompany, 'id' | 'payGroup'>
        ), employee: (
          { __typename?: 'Employee' }
          & Pick<Employee, 'id' | 'termsAcceptedAt'>
          & { providerBankAccount?: Maybe<(
            { __typename?: 'BankAccount' }
            & Pick<BankAccount, 'id' | 'accountNumber'>
          )> }
        ), summary: (
          { __typename?: 'PayPeriodSummary' }
          & Pick<PayPeriodSummary, 'netEarningsAmountCents'>
        ) }
      )> }
    ) }
  ) }
);

export type PresettlementExclusionsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  paymentExpectedOn?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type PresettlementExclusionsQuery = (
  { __typename?: 'PartnersQuery' }
  & { presettlementExclusions: (
    { __typename?: 'PresettlementExclusionConnection' }
    & Pick<PresettlementExclusionConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'PresettlementExclusion' }
      & Pick<PresettlementExclusion, 'id' | 'exclusionNote' | 'exclusionType'>
      & { payPeriod?: Maybe<(
        { __typename?: 'PayPeriod' }
        & Pick<PayPeriod, 'id'>
        & { summary: (
          { __typename?: 'PayPeriodSummary' }
          & Pick<PayPeriodSummary, 'netEarningsAmountCents' | 'remainderAmountCents' | 'totalTransferredEarlyAmountCents'>
        ) }
      )>, providerAccount: (
        { __typename?: 'ProviderAccount' }
        & Pick<ProviderAccount, 'id' | 'externalId'>
        & { company: (
          { __typename?: 'ProviderCompany' }
          & Pick<ProviderCompany, 'id' | 'payGroup'>
        ), employee: (
          { __typename?: 'Employee' }
          & Pick<Employee, 'id' | 'firstName' | 'lastName' | 'userStatus'>
        ) }
      ) }
    )> }
  ) }
);

export type GetProviderDisbursementsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  createdAtBetween?: Maybe<DateRangeInput>;
  requesterId?: Maybe<Scalars['ID']>;
}>;


export type GetProviderDisbursementsQuery = (
  { __typename?: 'PartnersQuery' }
  & { disbursements?: Maybe<(
    { __typename?: 'DisbursementConnection' }
    & Pick<DisbursementConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'Disbursement' }
      & Pick<Disbursement, 'createdAt' | 'disbursementReceivedOn' | 'totalAmountCents' | 'reason' | 'partnerInvoiceId' | 'status'>
      & { userBankAccount: (
        { __typename?: 'BankAccount' }
        & Pick<BankAccount, 'id' | 'name' | 'accountNumber'>
      ) | (
        { __typename?: 'DebitCard' }
        & Pick<DebitCard, 'id' | 'name' | 'accountNumber'>
      ), requester?: Maybe<(
        { __typename?: 'Employer' }
        & Pick<Employer, 'id' | 'firstName' | 'lastName'>
      )>, providerAccount: (
        { __typename?: 'ProviderAccount' }
        & Pick<ProviderAccount, 'id' | 'externalId'>
        & { employee: (
          { __typename?: 'Employee' }
          & Pick<Employee, 'firstName' | 'lastName'>
        ) }
      ) }
    )> }
  )> }
);

export type GetProviderMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderMetricsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id' | 'firstName' | 'lastName'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id'>
      & { metrics: (
        { __typename?: 'ProviderMetrics' }
        & Pick<ProviderMetrics, 'transferredLast7DaysCents' | 'eligible' | 'withRecentInvoices' | 'active' | 'champions'>
      ) }
    ) }
  ) }
);

export type GetRemainingRewardBudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRemainingRewardBudgetQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { employerRewardBudget: (
      { __typename?: 'EmployerRewardBudget' }
      & Pick<EmployerRewardBudget, 'remainingAmountCents'>
    ) }
  ) }
);

export type GetRewardsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  createdAtBetween?: Maybe<DateRangeInput>;
  requesterId?: Maybe<Scalars['ID']>;
  statuses?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetRewardsQuery = (
  { __typename?: 'PartnersQuery' }
  & { employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id'>
    & { currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id'>
      & { rewards: (
        { __typename?: 'RewardConnection' }
        & Pick<RewardConnection, 'totalCount'>
        & { items: Array<(
          { __typename?: 'Reward' }
          & Pick<Reward, 'id' | 'totalAmountCents' | 'notes' | 'createdAt' | 'approvedAt' | 'claimedAt' | 'status'>
          & { employee: (
            { __typename?: 'Employee' }
            & Pick<Employee, 'id' | 'firstName' | 'lastName'>
          ), employeeProfile: (
            { __typename?: 'EmployeeProfile' }
            & { externalIds: Array<(
              { __typename?: 'ExternalId' }
              & Pick<ExternalId, 'id' | 'primary'>
            )>, employeeLocation?: Maybe<(
              { __typename?: 'ProviderLocation' }
              & Pick<ProviderLocation, 'id' | 'name'>
            )> }
          ), requester: (
            { __typename?: 'Employer' }
            & Pick<Employer, 'id' | 'firstName' | 'lastName'>
          ), rewardBudget: (
            { __typename?: 'EmployerRewardBudget' }
            & { expectedApprovers?: Maybe<Array<(
              { __typename?: 'Employer' }
              & Pick<Employer, 'id'>
            )>> }
          ) }
        )> }
      ) }
    ) }
  ) }
);

export type GetUserRosterFilesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GetUserRosterFilesQuery = (
  { __typename?: 'PartnersQuery' }
  & { batchOnboardFiles: (
    { __typename?: 'BatchOnboardFileConnection' }
    & Pick<BatchOnboardFileConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'BatchOnboardFile' }
      & Pick<BatchOnboardFile, 'id' | 'status' | 'originalFilename' | 'createdAt'>
      & { creator: (
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
      ) }
    )> }
  ) }
);

export type PartnerQueryConfigQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
}>;


export type PartnerQueryConfigQuery = (
  { __typename?: 'PartnersQuery' }
  & { companies: (
    { __typename?: 'ProviderCompanyConnection' }
    & Pick<ProviderCompanyConnection, 'totalCount'>
    & { items: Array<(
      { __typename?: 'ProviderCompany' }
      & Pick<ProviderCompany, 'id' | 'payGroup'>
    )> }
  ), employer: (
    { __typename?: 'Employer' }
    & Pick<Employer, 'id' | 'firstName' | 'lastName'>
    & { providers: (
      { __typename?: 'ProviderConnection' }
      & { items: Array<(
        { __typename?: 'Provider' }
        & Pick<Provider, 'id' | 'icon' | 'name'>
      )> }
    ), associatedLocations: (
      { __typename?: 'ProviderLocationConnection' }
      & Pick<ProviderLocationConnection, 'totalCount'>
    ), currentProvider: (
      { __typename?: 'Provider' }
      & Pick<Provider, 'id' | 'icon' | 'name' | 'payrollExtenderEnabled' | 'allowedDomainNames' | 'fiservDebitPushEnabled' | 'enableTextMessages' | 'presettleManyDirectDepositBanks' | 'supportPhoneNumber' | 'refreshBalanceMessage' | 'whiteLabelPartnerIdentifier' | 'pendingUserSmsAllowed'>
      & { permissions: (
        { __typename?: 'ProviderPermissions' }
        & Pick<ProviderPermissions, 'canCreateBatchOnboard' | 'canViewBatchOnboard' | 'canShowBankAccounts' | 'canTerminateEmployee' | 'canUpdateEmployeeStatus' | 'canCreateGrossEarnings' | 'canCreateRewards' | 'canListRewards' | 'canCreateRewardBudgets' | 'canViewGrossEarnings' | 'canListGrossEarnings' | 'canCreateNetEarnings' | 'canListNetEarnings' | 'canViewPendingUpdateCount' | 'canDownloadDirectDepositUpdates' | 'canViewPayrollExtenderReports' | 'canGeneratePayrollExtenderReports' | 'canViewDirectDepositUpdates' | 'canShowApiLogs' | 'canCreateAdmins' | 'canListAdmins' | 'canUpdateAdminStatus' | 'canCreateDisbursements' | 'canListDisbursements' | 'canUpdateNotificationSettings' | 'canCreateDirectDepositUpdateFiles' | 'canViewComplianceReports' | 'canViewPresettlementExclusionReports' | 'canViewMetabaseReports' | 'canViewCycleReports' | 'canViewReports' | 'canViewDataExchange' | 'canListBatchDisbursements'>
      ), enabledFeatures: (
        { __typename?: 'FeatureConnection' }
        & { items: Array<(
          { __typename?: 'Feature' }
          & Pick<Feature, 'name'>
        )> }
      ), offCyclePaymentOptions: (
        { __typename?: 'OffCyclePaymentOptions' }
        & Pick<OffCyclePaymentOptions, 'cycleUserBankFeeCents' | 'cycleDpaFeeCents' | 'cycleRequiresApproval' | 'enableOffCycleDisbursements' | 'enableBatchOffCycleDisbursements' | 'maxAmountCents'>
      ), rewardOptions: (
        { __typename?: 'RewardOptions' }
        & Pick<RewardOptions, 'enableRewards' | 'canSendRewards' | 'maxMonthlyBudgetAmountCents'>
      ) }
    ) }
  ) }
);
